const dailyWord = {


    '2022-01-22': {
        word: 'ANOIS',
        meaning: 'jdfksdjsl',
        number: 1
    },
    '2022-01-23': {
        word: 'SEALL',
        number: 2
    },
    '2022-01-24': {
        word: 'FEARR',
        number: 3
    },
    '2022-01-25': {
        word: 'DUINE',
        number: 1
    },
    '2022-01-26': {
        word: 'ABAIR',
        number: 2
    },
    '2022-01-27': {
        word: 'MAITH',
        number: 3
    },
    '2022-01-28': {
        word: 'FAIGH',
        number: 4
    },
    '2022-01-29': {
        word: 'TÉIGH',
        number: 5
    },
    '2022-01-30': {
        word: 'NUAIR',
        number: 6
    },
    '2022-01-31': {
        word: 'AMACH',
        number: 7
    },
    '2022-02-01': {
        word: 'CEANN',
        number: 8
    },
    '2022-02-02': {
        word: 'CAITH',
        number: 9
    },
    '2022-02-03': {
        word: 'CHOMH',
        number: 10
    },
    '2022-02-04': {
        word: 'CHUIG',
        number: 11
    },
    '2022-02-05': {
        word: 'OBAIR',
        number: 12
    },
    '2022-02-06': {
        word: 'TAOBH',
        number: 13
    },
    '2022-02-07': {
        word: 'ANOIS',
        number: 14
    },
    '2022-02-08': {
        word: 'CÉILE',
        number: 15
    },
    '2022-02-09': {
        word: 'TEACH',
        number: 16
    },
    '2022-02-10': {
        word: 'CEART',
        number: 17
    },
    '2022-02-11': {
        word: 'SCÉAL',
        number: 18
    },
    '2022-02-12': {
        word: 'ROIMH',
        number: 19
    },
    '2022-02-13': {
        word: 'CEIST',
        number: 20
    },
    '2022-02-14': {
        word: 'PEATA',
        number: 21
    },
    '2022-02-15': {
        word: 'DÓIGH',
        number: 22
    },
    '2022-02-16': {
        word: 'POBAL',
        number: 23
    },
    '2022-02-17': {
        word: 'SCOIL',
        number: 24
    },
    '2022-02-18': {
        word: 'ROINN',
        number: 25
    },
    '2022-02-19': {
        word: 'ÚSÁID',
        number: 26
    },
    '2022-02-20': {
        word: 'LEITH',
        number: 27
    },
    '2022-02-21': {
        word: 'ANSEO',
        number: 28
    },
    '2022-02-22': {
        word: 'OÍCHE',
        number: 29
    },
    '2022-02-23': {
        word: 'BAILE',
        number: 30
    },
    '2022-02-24': {
        word: 'LUCHT',
        number: 31
    },
    '2022-02-25': {
        word: 'CÚRSA',
        number: 32
    },
    '2022-02-26': {
        word: 'EOLAS',
        number: 33
    },
    '2022-02-27': {
        word: 'IMIGH',
        number: 34
    },
    '2022-02-28': {
        word: 'CRÓGA',
        number: 35
    },
    '2022-03-01': {
        word: 'ÁBHAR',
        number: 36
    },
    '2022-03-02': {
        word: 'FÉACH',
        number: 37
    },
    '2022-03-03': {
        word: 'SIÚIL',
        number: 38
    },
    '2022-03-04': {
        word: 'ÉIGIN',
        number: 39
    },
    '2022-03-05': {
        word: 'BUAIL',
        number: 40
    },
    '2022-03-06': {
        word: 'RIAMH',
        number: 41
    },
    '2022-03-07': {
        word: 'FOCAL',
        number: 42
    },
    '2022-03-08': {
        word: 'INÍON',
        number: 43
    },
    '2022-03-09': {
        word: 'MEASA',
        number: 44
    },
    '2022-03-10': {
        word: 'CLOIS',
        number: 45
    },
    '2022-03-11': {
        word: 'CÓNAÍ',
        number: 46
    },
    '2022-03-12': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 47
    },
    '2022-03-13': {
        word: 'MINIC',
        meaning: 'jdfksdjsl',
        number: 48
    },
    '2022-03-14': {
        word: 'ANUAS',
        meaning: 'jdfksdjsl',
        number: 49
    },
    '2022-03-15': {
        word: 'IONAD',
        meaning: 'jdfksdjsl',
        number: 50
    },
    '2022-03-16': {
        word: 'CÓRAS',
        meaning: 'jdfksdjsl',
        number: 51
    },
    '2022-03-17': {
        word: 'FÉILE',
        meaning: 'jdfksdjsl',
        number: 52
    },
    '2022-03-18': {
        word: 'CÚPLA',
        meaning: 'jdfksdjsl',
        number: 53
    },
    '2022-03-19': {
        word: 'CÚIRT',
        meaning: 'jdfksdjsl',
        number: 54
    },
    '2022-03-20': {
        word: 'SÁSTA',
        meaning: 'jdfksdjsl',
        number: 55
    },
    '2022-03-21': {
        word: 'ÉIGSE', //OIFIG
        meaning: 'jdfksdjsl',
        number: 56
    },
    '2022-03-22': {
        word: 'UISCE',
        meaning: 'jdfksdjsl',
        number: 57
    },
    '2022-03-23': {
        word: 'MÓRÁN',
        meaning: 'jdfksdjsl',
        number: 58
    },
    '2022-03-24': {
        word: 'DORAS',
        meaning: 'jdfksdjsl',
        number: 59
    },
    '2022-03-25': {
        word: 'INNIU',
        meaning: 'jdfksdjsl',
        number: 60
    },
    '2022-03-26': {
        word: 'SUIGH',
        meaning: 'jdfksdjsl',
        number: 61
    },
    '2022-03-27': {
        word: 'MAMAÍ',
        meaning: 'jdfksdjsl',
        number: 62
    },
    '2022-03-28': {
        word: 'SRÁID',
        meaning: 'jdfksdjsl',
        number: 63
    },
    '2022-03-29': {
        word: 'CAILL',
        meaning: 'jdfksdjsl',
        number: 64
    },
    '2022-03-30': {
        word: 'GEARR',
        meaning: 'jdfksdjsl',
        number: 65
    },
    '2022-03-31': {
        word: 'ÁFACH',
        meaning: 'jdfksdjsl',
        number: 66
    },
    '2022-04-01': {
        word: 'BÓMÁN',
        meaning: 'jdfksdjsl',
        number: 67
    },
    '2022-04-02': {
        word: 'LUATH',
        meaning: 'jdfksdjsl',
        number: 68
    },
    '2022-04-03': {
        word: 'GRÚPA',
        meaning: 'jdfksdjsl',
        number: 69
    },
    '2022-04-04': {
        word: 'FADHB',
        meaning: 'jdfksdjsl',
        number: 70
    },
    '2022-04-05': {
        word: 'SCÉIM',
        meaning: 'jdfksdjsl',
        number: 71
    },
    '2022-04-06': {
        word: 'SEANS',
        meaning: 'tarlú gan choinne nó de thaisme',
        number: 72
    },
    '2022-04-07': {
        word: 'BOCHT',
        meaning: 'gan dóthain de riachtanais na beatha',
        number: 73
    },
    '2022-04-08': {
        word: 'THIAR',
        meaning: 'an treo a dtéann an ghrian faoi',
        number: 74
    },
    '2022-04-09': {
        word: 'TUILL',
        meaning: 'jdfksdjsl',
        number: 75
    },
    '2022-04-10': {
        word: 'LACHA',
        meaning: 'éan uisce agus gob fada leathan air',
        number: 76
    },
    '2022-04-11': {
        word: 'GAOTH',
        meaning: 'aer ag gluaiseacht',
        number: 77
    },
    '2022-04-12': {
        word: 'DREAM',
        meaning: 'grúpa daoine',
        number: 78
    },
    '2022-04-13': {
        word: 'CUMAS',
        meaning: 'ábaltacht, neart',
        number: 79
    },
    '2022-04-14': {
        word: 'TRÁTH',
        meaning: 'uair; am, ócáid; lá, tréimhse',
        number: 80
    },
    '2022-04-15': {
        word: 'LÉAMH',
        meaning: 'focail nó siombailí scríofa a thuiscint',
        number: 81
    },
    '2022-04-16': {
        word: 'STAIR',
        meaning: 'cuntas ar an saol atá caite',
        number: 82
    },
    '2022-04-17': {
        word: 'CÚRAM',
        meaning: 'aire, freagracht',
        number: 83
    },
    '2022-04-18': {
        word: 'ATHRÚ',
        meaning: 'jdfksdjsl',
        number: 84
    },
    '2022-04-19': {
        word: 'TOISC',
        meaning: 'jdfksdjsl',
        number: 85
    },
    '2022-04-20': {
        word: 'LITIR',
        meaning: 'jdfksdjsl',
        number: 86
    },
    '2022-04-21': {
        word: 'PÁIRT',
        meaning: 'jdfksdjsl',
        number: 87
    },
    '2022-04-22': {
        word: 'CLOCH',
        meaning: 'jdfksdjsl',
        number: 88
    },
    '2022-04-23': {
        word: 'SOLAS',
        meaning: 'jdfksdjsl',
        number: 89
    },
    '2022-04-24': {
        word: 'FOIRM',
        meaning: 'jdfksdjsl',
        number: 90
    },
    '2022-04-25': {
        word: 'CRANN', // LITIR
        meaning: 'jdfksdjsl',
        number: 91
    },
    '2022-04-26': {
        word: 'PLEAN',
        meaning: 'jdfksdjsl',
        number: 92
    },
    '2022-04-27': {
        word: 'PÁIRC',
        meaning: 'jdfksdjsl',
        number: 93
    },
    '2022-04-28': {
        word: 'LÉANN',
        meaning: 'jdfksdjsl',
        number: 94
    },
    '2022-04-29': {
        word: 'RINCE', //ROGHA
        meaning: 'jdfksdjsl',
        number: 95
    },
    '2022-04-30': {
        word: 'DEASA', // International Jazz Day  LEATH
        meaning: 'jdfksdjsl',
        number: 96
    },
    '2022-05-01': {
        word: 'UASAL',
        meaning: 'jdfksdjsl',
        number: 97
    },
    '2022-05-02': {
        word: 'CONAS',
        meaning: 'jdfksdjsl',
        number: 98
    },
    '2022-05-03': {
        word: 'LÉIGH',
        meaning: 'jdfksdjsl',
        number: 99
    },
    '2022-05-04': {
        word: 'GRIAN',
        meaning: 'jdfksdjsl',
        number: 100
    },
    '2022-05-05': {
        word: 'DÓCHA',
        meaning: 'jdfksdjsl',
        number: 101
    },
    '2022-05-06': {
        word: 'PÍOSA',
        meaning: 'jdfksdjsl',
        number: 102
    },
    '2022-05-07': {
        word: 'THÍOS',
        meaning: 'jdfksdjsl',
        number: 103
    },
    '2022-05-08': {
        word: 'FÓILL',
        meaning: 'jdfksdjsl',
        number: 104
    },
    '2022-05-09': {
        word: 'TURAS',
        meaning: 'jdfksdjsl',
        number: 105
    },
    '2022-05-10': {
        word: 'LUIGH',
        meaning: 'jdfksdjsl',
        number: 106
    },
    '2022-05-11': {
        word: 'RIAIL',
        meaning: 'jdfksdjsl',
        number: 107
    },
    '2022-05-12': {
        word: 'FÓGRA',
        meaning: 'jdfksdjsl',
        number: 108
    },
    '2022-05-13': {
        word: 'THUAS',
        meaning: 'jdfksdjsl',
        number: 109
    },
    '2022-05-14': {
        word: 'BEART',
        meaning: 'jdfksdjsl',
        number: 110
    },
    '2022-05-15': {
        word: 'CLANN',
        meaning: 'jdfksdjsl',
        number: 111
    },
    '2022-05-16': {
        word: 'DEARA',
        meaning: 'jdfksdjsl',
        number: 112
    },
    '2022-05-17': {
        word: 'SIOPA',
        meaning: 'jdfksdjsl',
        number: 113
    },
    '2022-05-18': {
        word: 'LEABA',
        meaning: 'jdfksdjsl',
        number: 114
    },
    '2022-05-19': {
        word: 'DEICH',
        meaning: 'jdfksdjsl',
        number: 115
    },
    '2022-05-20': {
        word: 'BEACH', // World bee day DEARG
        meaning: 'jdfksdjsl',
        number: 116
    },
    '2022-05-21': {
        word: 'DEARG', // Dearg le Fearg Eagla
        meaning: 'jdfksdjsl',
        number: 117
    },
    '2022-05-22': {
        word: 'BAINT',
        meaning: 'jdfksdjsl',
        number: 118
    },
    '2022-05-23': {
        word: 'GARDA',
        meaning: 'jdfksdjsl',
        number: 119
    },
    '2022-05-24': {
        word: 'DRÁMA',
        meaning: 'jdfksdjsl',
        number: 120
    },
    '2022-05-25': {
        word: 'FICHE',
        meaning: 'jdfksdjsl',
        number: 121
    },
    '2022-05-26': {
        word: 'LUACH',
        meaning: 'jdfksdjsl',
        number: 122
    },
    '2022-05-27': {
        word: 'RÉIDH',
        meaning: 'jdfksdjsl',
        number: 123
    },
    '2022-05-28': {
        word: 'NEART',
        meaning: 'jdfksdjsl',
        number: 124
    },
    '2022-05-29': {
        word: 'TRIÚR',
        meaning: 'jdfksdjsl',
        number: 125
    },
    '2022-05-30': {
        word: 'AONAR',
        meaning: 'jdfksdjsl',
        number: 126
    },
    '2022-05-31': {
        word: 'PRIOC',
        meaning: 'jdfksdjsl',
        number: 127
    },
    '2022-06-01': {
        word: 'MARBH',
        meaning: 'jdfksdjsl',
        number: 128
    },
    '2022-06-02': {
        word: 'DEOCH',
        meaning: 'jdfksdjsl',
        number: 129
    },
    '2022-06-03': {
        word: 'GREIM',
        meaning: 'jdfksdjsl',
        number: 130,
        emoji: '🚲' // world bicycle day
    },
    '2022-06-04': {
        word: 'FOSTA',
        meaning: 'jdfksdjsl',
        number: 131
    },
    '2022-06-05': {
        word: 'DALTA',
        meaning: 'jdfksdjsl',
        number: 132
    },
    '2022-06-06': {
        word: 'DROIM',
        meaning: 'jdfksdjsl',
        number: 133
    },
    '2022-06-07': {
        word: 'TROID',
        meaning: 'jdfksdjsl',
        number: 134
    },
    '2022-06-08': {
        word: 'BHUEL',
        meaning: 'jdfksdjsl',
        number: 135,
        emoji: '🌊' // world oceans day
    },
    '2022-06-09': {
        word: 'ÓCÁID',
        meaning: 'jdfksdjsl',
        number: 136
    },
    '2022-06-10': {
        word: 'TUATH',
        meaning: 'jdfksdjsl',
        number: 137
    },
    '2022-06-11': {
        word: 'BRATH',
        meaning: 'jdfksdjsl',
        number: 138
    },
    '2022-06-12': {
        word: 'CIALL',
        meaning: 'jdfksdjsl',
        number: 139
    },
    '2022-06-13': {
        word: 'AIRDE',
        meaning: 'jdfksdjsl',
        number: 140
    },
    '2022-06-14': {
        word: 'FORAS',
        meaning: 'jdfksdjsl',
        number: 141
    },
    '2022-06-15': {
        word: 'SPÉIS',
        meaning: 'jdfksdjsl',
        number: 142
    },
    '2022-06-16': {
        word: 'BEIRT',
        meaning: 'jdfksdjsl',
        number: 143
    },
    '2022-06-17': {
        word: 'SPÓRT',
        meaning: 'jdfksdjsl',
        number: 144
    },
    '2022-06-18': {
        word: 'GNÁTH',
        meaning: 'jdfksdjsl',
        number: 145
    },
    '2022-06-19': {
        word: 'DAIDÍ', // fathers day
        meaning: 'jdfksdjsl',
        number: 146
    },
    '2022-06-20': {
        word: 'SOCRÚ',
        meaning: 'jdfksdjsl',
        number: 147
    },
    '2022-06-21': {
        word: 'BLÁTH',
        meaning: 'jdfksdjsl',
        number: 148
    },
    '2022-06-22': {
        word: 'THALL',
        meaning: 'jdfksdjsl',
        number: 149
    },
    '2022-06-23': {
        word: 'ÍSEAL',
        meaning: 'jdfksdjsl',
        number: 150
    },
    '2022-06-24': {
        word: 'GLÚIN',
        meaning: 'jdfksdjsl',
        number: 151
    },
    '2022-06-25': {
        word: 'AIGNE',
        meaning: 'jdfksdjsl',
        number: 152
    },
    '2022-06-26': {
        word: 'EARRA',
        meaning: 'jdfksdjsl',
        number: 153
    },
    '2022-06-27': {
        word: 'AONAD',
        meaning: 'jdfksdjsl',
        number: 154
    },
    '2022-06-28': {
        word: 'DUAIS',
        meaning: 'jdfksdjsl',
        number: 155
    },
    '2022-06-29': {
        word: 'BALLA',
        meaning: 'jdfksdjsl',
        number: 156
    },
    '2022-06-30': {
        word: 'MEALL',
        meaning: 'jdfksdjsl',
        number: 157
    },
    '2022-07-01': {
        word: 'ANÍOS',
        meaning: 'jdfksdjsl',
        number: 158
    },
    '2022-07-02': {
        word: 'BILLE',
        meaning: 'jdfksdjsl',
        number: 159
    },
    '2022-07-03': {
        word: 'NOCHT',
        meaning: 'jdfksdjsl',
        number: 160
    },
    '2022-07-04': {
        word: 'AIDHM',
        meaning: 'jdfksdjsl',
        number: 161
    },
    '2022-07-05': {
        word: 'SPÉIR',
        meaning: 'jdfksdjsl',
        number: 162
    },
    '2022-07-06': {
        word: 'BREAC',
        meaning: 'jdfksdjsl',
        number: 163
    },
    '2022-07-07': {
        word: 'EASPA',
        meaning: 'jdfksdjsl',
        number: 164
    },
    '2022-07-08': {
        word: 'GALAR',
        meaning: 'jdfksdjsl',
        number: 165
    },
    '2022-07-09': {
        word: 'GASÚR',
        meaning: 'jdfksdjsl',
        number: 166
    },
    '2022-07-10': {
        word: 'CIÚIN',
        meaning: 'jdfksdjsl',
        number: 167
    },
    '2022-07-11': {
        word: 'BOSCA',
        meaning: 'jdfksdjsl',
        number: 168
    },
    '2022-07-12': {
        word: 'THEAS',
        meaning: 'jdfksdjsl',
        number: 169
    },
    '2022-07-13': {
        word: 'URLÁR',
        meaning: 'jdfksdjsl',
        number: 170
    },
    '2022-07-14': {
        word: 'IOMAÍ',
        meaning: 'jdfksdjsl',
        number: 171
    },
    '2022-07-15': {
        word: 'TEANN',
        meaning: 'jdfksdjsl',
        number: 172
    },
    '2022-07-16': {
        word: 'CROCH',
        meaning: 'jdfksdjsl',
        number: 173
    },
    '2022-07-17': {
        word: 'FÓRSA',
        meaning: 'jdfksdjsl',
        number: 174
    },
    '2022-07-18': {
        word: 'MADRA',
        meaning: 'jdfksdjsl',
        number: 175
    },
    '2022-07-19': {
        word: 'LAOCH',
        meaning: 'jdfksdjsl',
        number: 176
    },
    '2022-07-20': {
        word: 'LEASÚ',
        meaning: 'jdfksdjsl',
        number: 177,
        emoji: '🌙' // International Moon Day
    },
    '2022-07-21': {
        word: 'CÓSTA',
        meaning: 'jdfksdjsl',
        number: 178
    },
    '2022-07-22': {
        word: 'CRUTH',
        meaning: 'jdfksdjsl',
        number: 179
    },
    '2022-07-23': {
        word: 'ÁTHAS',
        meaning: 'jdfksdjsl',
        number: 180
    },
    '2022-07-24': {
        word: 'ANONN',
        meaning: 'jdfksdjsl',
        number: 181
    },
    '2022-07-25': {
        word: 'TÉACS',
        meaning: 'jdfksdjsl',
        number: 182
    },
    '2022-07-26': {
        word: 'FEIRM',
        meaning: 'jdfksdjsl',
        number: 183
    },
    '2022-07-27': {
        word: 'HALLA',
        meaning: 'jdfksdjsl',
        number: 184
    },
    '2022-07-28': {
        word: 'ARAON',
        meaning: 'jdfksdjsl',
        number: 185
    },
    '2022-07-29': {
        word: 'GLÉAS',
        meaning: 'jdfksdjsl',
        number: 186
    },
    '2022-07-30': {
        word: 'MISTE',
        meaning: 'jdfksdjsl',
        number: 187
    },
    '2022-07-31': {
        word: 'BRÉAG',
        meaning: 'jdfksdjsl',
        number: 188
    },
    '2022-08-01': {
        word: 'GUNNA',
        meaning: 'jdfksdjsl',
        number: 189
    },
    '2022-08-02': {
        word: 'CAORA',
        meaning: 'jdfksdjsl',
        number: 190
    },
    '2022-08-03': {
        word: 'ANIAR',
        meaning: 'jdfksdjsl',
        number: 191
    },
    '2022-08-04': {
        word: 'DEARC',
        meaning: 'jdfksdjsl',
        number: 192
    },
    '2022-08-05': {
        word: 'MOILL',
        meaning: 'jdfksdjsl',
        number: 193
    },
    '2022-08-06': {
        word: 'SNÁMH',
        meaning: 'jdfksdjsl',
        number: 194
    },
    '2022-08-07': {
        word: 'PLUID',
        meaning: 'jdfksdjsl',
        number: 195
    },
    '2022-08-08': {
        word: 'SÍNIÚ',
        meaning: 'jdfksdjsl',
        number: 196
    },
    '2022-08-09': {
        word: 'CNÁMH',
        meaning: 'jdfksdjsl',
        number: 197
    },
    '2022-08-10': {
        word: 'GÉILL',
        meaning: 'jdfksdjsl',
        number: 198
    },
    '2022-08-11': {
        word: 'CAOIN',
        meaning: 'jdfksdjsl',
        number: 199
    },
    '2022-08-12': {
        word: 'CÁRTA',
        meaning: 'jdfksdjsl',
        number: 200
    },
    '2022-08-13': {
        word: 'ACHAR',
        meaning: 'jdfksdjsl',
        number: 201
    },
    '2022-08-14': {
        word: 'CÚIGE',
        meaning: 'jdfksdjsl',
        number: 202
    },
    '2022-08-15': {
        word: 'IONAS',
        meaning: 'jdfksdjsl',
        number: 203
    },
    '2022-08-16': {
        word: 'BÁIGH',
        meaning: 'jdfksdjsl',
        number: 204
    },
    '2022-08-17': {
        word: 'SRUTH',
        meaning: 'jdfksdjsl',
        number: 205
    },
    '2022-08-18': {
        word: 'FEOIL',
        meaning: 'jdfksdjsl',
        number: 206
    },
    '2022-08-19': {
        word: 'DÍLIS',
        meaning: 'jdfksdjsl',
        number: 207
    },
    '2022-08-20': {
        word: 'LOCHT',
        meaning: 'jdfksdjsl',
        number: 208
    },
    '2022-08-21': {
        word: 'ÉADAN',
        meaning: 'jdfksdjsl',
        number: 209
    },
    '2022-08-22': {
        word: 'RÚNAÍ',
        meaning: 'jdfksdjsl',
        number: 210
    },
    '2022-08-23': {
        word: 'STAID',
        meaning: 'jdfksdjsl',
        number: 211
    },
    '2022-08-24': {
        word: 'ÉASCA',
        meaning: 'jdfksdjsl',
        number: 212
    },
    '2022-08-25': {
        word: 'SCAIP',
        meaning: 'jdfksdjsl',
        number: 213
    },
    '2022-08-26': {
        word: 'AISTE',
        meaning: 'jdfksdjsl',
        number: 214
    },
    '2022-08-27': {
        word: 'SCOTH',
        meaning: 'jdfksdjsl',
        number: 215
    },
    '2022-08-28': {
        word: 'DRUID',
        meaning: 'jdfksdjsl',
        number: 216
    },
    '2022-08-29': {
        word: 'CISTE',
        meaning: 'jdfksdjsl',
        number: 217
    },
    '2022-08-30': {
        word: 'TÉAMA',
        meaning: 'jdfksdjsl',
        number: 218
    },
    '2022-08-31': {
        word: 'TAIRG',
        meaning: 'jdfksdjsl',
        number: 219
    },
    '2022-09-01': {
        word: 'OCRAS',
        meaning: 'jdfksdjsl',
        number: 220
    },
    '2022-09-02': {
        word: 'MAÍGH',
        meaning: 'jdfksdjsl',
        number: 221
    },
    '2022-09-03': {
        word: 'DEOIR',
        meaning: 'jdfksdjsl',
        number: 222
    },
    '2022-09-04': {
        word: 'SEINN',
        meaning: 'jdfksdjsl',
        number: 223
    },
    '2022-09-05': {
        word: 'SONRA',
        meaning: 'jdfksdjsl',
        number: 224
    },
    '2022-09-06': {
        word: 'TOBAR',
        meaning: 'jdfksdjsl',
        number: 225
    },
    '2022-09-07': {
        word: 'BÉILE',
        meaning: 'jdfksdjsl',
        number: 226
    },
    '2022-09-08': {
        word: 'COILL',
        meaning: 'jdfksdjsl',
        number: 227
    },
    '2022-09-09': {
        word: 'LÍOFA',
        meaning: 'jdfksdjsl',
        number: 228
    },
    '2022-09-10': {
        word: 'ÓSTÁN',
        meaning: 'jdfksdjsl',
        number: 229
    },
    '2022-09-11': {
        word: 'MAOIN',
        meaning: 'jdfksdjsl',
        number: 230
    },
    '2022-09-12': {
        word: 'ACHAN',
        meaning: 'jdfksdjsl',
        number: 231
    },
    '2022-09-13': {
        word: 'NÁIRE',
        meaning: 'jdfksdjsl',
        number: 232
    },
    '2022-09-14': {
        word: 'BUNÚS',
        meaning: 'jdfksdjsl',
        number: 233
    },
    '2022-09-15': {
        word: 'ANALL',
        meaning: 'jdfksdjsl',
        number: 234
    },
    '2022-09-16': {
        word: 'GNÁCH',
        meaning: 'jdfksdjsl',
        number: 235
    },
    '2022-09-17': {
        word: 'SCÁTH',
        meaning: 'jdfksdjsl',
        number: 236
    },
    '2022-09-18': {
        word: 'TRÉIG',
        meaning: 'jdfksdjsl',
        number: 237
    },
    '2022-09-19': {
        word: 'MÉADÚ',
        meaning: 'jdfksdjsl',
        number: 238
    },
    '2022-09-20': {
        word: 'CRAOL',
        meaning: 'jdfksdjsl',
        number: 239
    },
    '2022-09-21': {
        word: 'ÍOMHÁ',
        meaning: 'jdfksdjsl',
        number: 240
    },
    '2022-09-22': {
        word: 'OTHAR',
        meaning: 'jdfksdjsl',
        number: 241
    },
    '2022-09-23': {
        word: 'AICME',
        meaning: 'jdfksdjsl',
        number: 242
    },
    '2022-09-24': {
        word: 'FUAIM',
        meaning: 'jdfksdjsl',
        number: 243
    },
    '2022-09-25': {
        word: 'GAIRM',
        meaning: 'jdfksdjsl',
        number: 244
    },
    '2022-09-26': {
        word: 'SÁIGH',
        meaning: 'jdfksdjsl',
        number: 245
    },
    '2022-09-27': {
        word: 'TIRIM',
        meaning: 'jdfksdjsl',
        number: 246
    },
    '2022-09-28': {
        word: 'BÁIRE',
        meaning: 'jdfksdjsl',
        number: 247
    },
    '2022-09-29': {
        word: 'CEIRD',
        meaning: 'jdfksdjsl',
        number: 248
    },
    '2022-09-30': {
        word: 'GARBH',
        meaning: 'jdfksdjsl',
        number: 249
    },
    '2022-10-01': {
        word: 'GEATA',
        meaning: 'jdfksdjsl',
        number: 250
    },
    '2022-10-02': {
        word: 'LIATH',
        meaning: 'jdfksdjsl',
        number: 251
    },
    '2022-10-03': {
        word: 'MAIDE',
        meaning: 'jdfksdjsl',
        number: 252
    },
    '2022-10-04': {
        word: 'NAOFA',
        meaning: 'jdfksdjsl',
        number: 253
    },
    '2022-10-05': {
        word: 'UAIGH',
        meaning: 'jdfksdjsl',
        number: 254,
        emoji: '👩‍🏫' // world teachers' day
    },
    '2022-10-06': {
        word: 'CLUIN',
        meaning: 'jdfksdjsl',
        number: 255
    },
    '2022-10-07': {
        word: 'DABHT',
        meaning: 'jdfksdjsl',
        number: 256
    },
    '2022-10-08': {
        word: 'BRAON',
        meaning: 'jdfksdjsl',
        number: 257
    },
    '2022-10-09': {
        word: 'UAFÁS',
        meaning: 'jdfksdjsl',
        number: 258
    },
    '2022-10-10': {
        word: 'TÁBLA',
        meaning: 'jdfksdjsl',
        number: 259
    },
    '2022-10-11': {
        word: 'TRÉAN',
        meaning: 'jdfksdjsl',
        number: 260
    },
    '2022-10-12': {
        word: 'BANNA',
        meaning: 'jdfksdjsl',
        number: 261
    },
    '2022-10-13': {
        word: 'CAIRT',
        meaning: 'jdfksdjsl',
        number: 262
    },
    '2022-10-14': {
        word: 'CLUAS',
        meaning: 'jdfksdjsl',
        number: 263
    },
    '2022-10-15': {
        word: 'BINSE',
        meaning: 'jdfksdjsl',
        number: 264
    },
    '2022-10-16': {
        word: 'ANÁIL',
        meaning: 'jdfksdjsl',
        number: 265
    },
    '2022-10-17': {
        word: 'NEAMH',
        meaning: 'jdfksdjsl',
        number: 266
    },
    '2022-10-18': {
        word: 'NÁDÚR',
        meaning: 'jdfksdjsl',
        number: 267
    },
    '2022-10-19': {
        word: 'FÁSTA',
        meaning: 'jdfksdjsl',
        number: 268
    },
    '2022-10-20': {
        word: 'COSÁN',
        meaning: 'jdfksdjsl',
        number: 269
    },
    '2022-10-21': {
        word: 'ARDÁN',
        meaning: 'jdfksdjsl',
        number: 270
    },
    '2022-10-22': {
        word: 'FEADH',
        meaning: 'jdfksdjsl',
        number: 271
    },
    '2022-10-23': {
        word: 'FEARG',
        meaning: 'jdfksdjsl',
        number: 272
    },
    '2022-10-24': {
        word: 'CÚLRA',
        meaning: 'jdfksdjsl',
        number: 273
    },
    '2022-10-25': {
        word: 'AISCE',
        meaning: 'jdfksdjsl',
        number: 274
    },
    '2022-10-26': {
        word: 'PEANN',
        meaning: 'jdfksdjsl',
        number: 275
    },
    '2022-10-27': {
        word: 'SRIAN',
        meaning: 'jdfksdjsl',
        number: 276
    },
    '2022-10-28': {
        word: 'ARÉIR',
        meaning: 'jdfksdjsl',
        number: 277
    },
    '2022-10-29': {
        word: 'CAITE',
        meaning: 'jdfksdjsl',
        number: 278
    },
    '2022-10-30': {
        word: 'CLAON',
        meaning: 'jdfksdjsl',
        number: 279
    },
    '2022-10-31': {
        word: 'GORTA',
        meaning: 'jdfksdjsl',
        number: 280
    },
    '2022-11-01': {
        word: 'FIACH',
        meaning: 'jdfksdjsl',
        number: 281
    },
    '2022-11-02': {
        word: 'CASTA',
        meaning: 'jdfksdjsl',
        number: 282
    },
    '2022-11-03': {
        word: 'DLÚTH',
        meaning: 'jdfksdjsl',
        number: 283
    },
    '2022-11-04': {
        word: 'CAOGA',
        meaning: 'jdfksdjsl',
        number: 284
    },
    '2022-11-05': {
        word: 'MÍNIÚ',
        meaning: 'jdfksdjsl',
        number: 285
    },
    '2022-11-06': {
        word: 'PÉIRE',
        meaning: 'jdfksdjsl',
        number: 286
    },
    '2022-11-07': {
        word: 'LÁIGH',
        meaning: 'jdfksdjsl',
        number: 287
    },
    '2022-11-08': {
        word: 'ROGHA',
        meaning: 'jdfksdjsl',
        number: 288
    },
    '2022-11-09': {
        word: 'BARRA',
        meaning: 'jdfksdjsl',
        number: 289
    },
    '2022-11-10': {
        word: 'CEARC',
        meaning: 'jdfksdjsl',
        number: 290
    },
    '2022-11-11': {
        word: 'DEALG',
        meaning: 'jdfksdjsl',
        number: 291
    },
    '2022-11-12': {
        word: 'SCUAB',
        meaning: 'jdfksdjsl',
        number: 292
    },
    '2022-11-13': {
        word: 'PRÁTA',
        meaning: 'jdfksdjsl',
        number: 293
    },
    '2022-11-14': {
        word: 'NAOMH',
        meaning: 'jdfksdjsl',
        number: 294
    },
    '2022-11-15': {
        word: 'CLEAS',
        meaning: 'jdfksdjsl',
        number: 295
    },
    '2022-11-16': {
        word: 'RUAIG',
        meaning: 'jdfksdjsl',
        number: 296
    },
    '2022-11-17': {
        word: 'GUIGH',
        meaning: 'jdfksdjsl',
        number: 297
    },
    '2022-11-18': {
        word: 'SCOIR',
        meaning: 'jdfksdjsl',
        number: 298
    },
    '2022-11-19': {
        word: 'ARMAS',
        meaning: 'jdfksdjsl',
        number: 299
    },
    '2022-11-20': {
        word: 'FIÁIN',
        meaning: 'jdfksdjsl',
        number: 300
    },
    '2022-11-21': {
        word: 'PEACA',
        meaning: 'jdfksdjsl',
        number: 301
    },
    '2022-11-22': {
        word: 'PREAB',
        meaning: 'jdfksdjsl',
        number: 302
    },
    '2022-11-23': {
        word: 'TAISE',
        meaning: 'jdfksdjsl',
        number: 303
    },
    '2022-11-24': {
        word: 'SCÁLA',
        meaning: 'jdfksdjsl',
        number: 304
    },
    '2022-11-25': {
        word: 'GRINN',
        meaning: 'jdfksdjsl',
        number: 305
    },
    '2022-11-26': {
        word: 'BRÁCH',
        meaning: 'jdfksdjsl',
        number: 306
    },
    '2022-11-27': {
        word: 'ONÓIR',
        meaning: 'jdfksdjsl',
        number: 307
    },
    '2022-11-28': {
        word: 'BUILE',
        meaning: 'jdfksdjsl',
        number: 308
    },
    '2022-11-29': {
        word: 'TITIM',
        meaning: 'jdfksdjsl',
        number: 309
    },
    '2022-11-30': {
        word: 'AGÓID',
        meaning: 'jdfksdjsl',
        number: 310
    },
    '2022-12-01': {
        word: 'COLÚN',
        meaning: 'jdfksdjsl',
        number: 311
    },
    '2022-12-02': {
        word: 'BRÉAN',
        meaning: 'jdfksdjsl',
        number: 312
    },
    '2022-12-03': {
        word: 'TEITH',
        meaning: 'jdfksdjsl',
        number: 313
    },
    '2022-12-04': {
        word: 'EAGAR',
        meaning: 'jdfksdjsl',
        number: 314
    },
    '2022-12-05': {
        word: 'RÍOGA',
        meaning: 'jdfksdjsl',
        number: 315
    },
    '2022-12-06': {
        word: 'EOLAÍ',
        meaning: 'jdfksdjsl',
        number: 316
    },
    '2022-12-07': {
        word: 'PÓSTA',
        meaning: 'jdfksdjsl',
        number: 317
    },
    '2022-12-08': {
        word: 'ABHUS',
        meaning: 'jdfksdjsl',
        number: 318
    },
    '2022-12-09': {
        word: 'FUATH',
        meaning: 'jdfksdjsl',
        number: 319
    },
    '2022-12-10': {
        word: 'RÍOMH',
        meaning: 'jdfksdjsl',
        number: 320
    },
    '2022-12-11': {
        word: 'DÍOMÁ',
        meaning: 'jdfksdjsl',
        number: 321
    },
    '2022-12-12': {
        word: 'CUPÁN',
        meaning: 'jdfksdjsl',
        number: 322
    },
    '2022-12-13': {
        word: 'BUÍON',
        meaning: 'jdfksdjsl',
        number: 323
    },
    '2022-12-14': {
        word: 'GLEIC',
        meaning: 'jdfksdjsl',
        number: 324
    },
    '2022-12-15': {
        word: 'ÉACHT',
        meaning: 'jdfksdjsl',
        number: 325
    },
    '2022-12-16': {
        word: 'DLIGH',
        meaning: 'jdfksdjsl',
        number: 326
    },
    '2022-12-17': {
        word: 'SCIAN',
        meaning: 'jdfksdjsl',
        number: 327
    },
    '2022-12-18': {
        word: 'FÁISC',
        meaning: 'jdfksdjsl',
        number: 328
    },
    '2022-12-19': {
        word: 'PLÁTA',
        meaning: 'jdfksdjsl',
        number: 329
    },
    '2022-12-20': {
        word: 'ITHIR',
        meaning: 'jdfksdjsl',
        number: 330
    },
    '2022-12-21': {
        word: 'IOMAD',
        meaning: 'jdfksdjsl',
        number: 331
    },
    '2022-12-22': {
        word: 'DÍBIR',
        meaning: 'jdfksdjsl',
        number: 332
    },
    '2022-12-23': {
        word: 'SCÁIL',
        meaning: 'jdfksdjsl',
        number: 333
    },
    '2022-12-24': {
        word: 'EITIL',
        meaning: 'jdfksdjsl',
        number: 334
    },
    '2022-12-25': {
        word: 'FEITH',
        meaning: 'jdfksdjsl',
        number: 335
    },
    '2022-12-26': {
        word: 'TOBAC',
        meaning: 'jdfksdjsl',
        number: 336
    },
    '2022-12-27': {
        word: 'FIONN',
        meaning: 'jdfksdjsl',
        number: 337
    },
    '2022-12-28': {
        word: 'CRITH',
        meaning: 'jdfksdjsl',
        number: 338
    },
    '2022-12-29': {
        word: 'TEIST',
        meaning: 'jdfksdjsl',
        number: 339
    },
    '2022-12-30': {
        word: 'BRÁID',
        meaning: 'jdfksdjsl',
        number: 340
    },
    '2022-12-31': {
        word: 'LÉINE',
        meaning: 'jdfksdjsl',
        number: 341
    },
    '2023-01-01': {
        word: 'SCATA',
        meaning: 'jdfksdjsl',
        number: 342
    },
    '2023-01-02': {
        word: 'GIOTA',
        meaning: 'jdfksdjsl',
        number: 343
    },
    '2023-01-03': {
        word: 'FEALL',
        meaning: 'jdfksdjsl',
        number: 344
    },
    '2023-01-04': {
        word: 'SCAIR',
        meaning: 'jdfksdjsl',
        number: 345
    },'2023-01-05': {
        word: 'TOIRT',
        meaning: 'jdfksdjsl',
        number: 346
    },'2023-01-06': {
        word: 'SCIOB',
        meaning: 'jdfksdjsl',
        number: 347
    },'2023-01-07': {
        word: 'DAITE',
        meaning: 'jdfksdjsl',
        number: 348
    },'2023-01-08': {
        word: 'RÉIGH',
        meaning: 'jdfksdjsl',
        number: 349
    },'2023-01-09': {
        word: 'COGAR',
        meaning: 'jdfksdjsl',
        number: 350
    },'2023-01-10': {
        word: 'TANAÍ',
        meaning: 'jdfksdjsl',
        number: 351
    },'2023-01-11': {
        word: 'OIBRÍ',
        meaning: 'jdfksdjsl',
        number: 352
    },'2023-01-12': {
        word: 'SUITE',
        meaning: 'jdfksdjsl',
        number: 353
    },'2023-01-13': {
        word: 'MUISE',
        meaning: 'jdfksdjsl',
        number: 354
    },'2023-01-14': {
        word: 'CAMPA',
        meaning: 'jdfksdjsl',
        number: 355
    },'2023-01-15': {
        word: 'RÚNDA',
        meaning: 'jdfksdjsl',
        number: 356
    },'2023-01-16': {
        word: 'TOGHA',
        meaning: 'jdfksdjsl',
        number: 357
    },'2023-01-17': {
        word: 'DÚNTA',
        meaning: 'jdfksdjsl',
        number: 358
    },'2023-01-18': {
        word: 'CLÉIR',
        meaning: 'jdfksdjsl',
        number: 359
    },'2023-01-19': {
        word: 'GNÉAS',
        meaning: 'jdfksdjsl',
        number: 360
    },'2023-01-20': {
        word: 'GASTA',
        meaning: 'jdfksdjsl',
        number: 361
    },'2023-01-21': {
        word: 'TÁIRG',
        meaning: 'jdfksdjsl',
        number: 362
    },'2023-01-22': {
        word: 'ALLAS',
        meaning: 'jdfksdjsl',
        number: 363
    },'2023-01-23': {
        word: 'SÁILE',
        meaning: 'jdfksdjsl',
        number: 364
    },'2023-01-24': {
        word: 'DOIRT',
        meaning: 'jdfksdjsl',
        number: 365
    },'2023-01-25': {
        word: 'DÚLRA',
        meaning: 'jdfksdjsl',
        number: 366
    },'2023-01-26': {
        word: 'TIUBH',
        meaning: 'jdfksdjsl',
        number: 367
    },'2023-01-27': {
        word: 'FINNÉ',
        meaning: 'jdfksdjsl',
        number: 368
    },'2023-01-28': {
        word: 'BOTÚN',
        meaning: 'jdfksdjsl',
        number: 369
    },'2023-01-29': {
        word: 'ALBAM',
        meaning: 'jdfksdjsl',
        number: 370
    },'2023-01-30': {
        word: 'PÍOPA',
        meaning: 'jdfksdjsl',
        number: 371
    },'2023-01-31': {
        word: 'TOGRA',
        meaning: 'jdfksdjsl',
        number: 372
    },'2023-02-01': {
        word: 'ÓRÁID',
        meaning: 'jdfksdjsl',
        number: 373
    },'2023-02-02': {
        word: 'BLAIS',
        meaning: 'jdfksdjsl',
        number: 374
    },'2023-02-03': {
        word: 'SEACH',
        meaning: 'jdfksdjsl',
        number: 375
    },'2023-02-04': {
        word: 'NEACH',
        meaning: 'jdfksdjsl',
        number: 376
    },'2023-02-05': {
        word: 'FAILL',
        meaning: 'jdfksdjsl',
        number: 377
    },'2023-02-06': {
        word: 'MILIS',
        meaning: 'jdfksdjsl',
        number: 378
    },'2023-02-07': {
        word: 'TARBH',
        meaning: 'jdfksdjsl',
        number: 379
    },'2023-02-08': {
        word: 'MÚNLA',
        meaning: 'jdfksdjsl',
        number: 380
    },'2023-02-09': {
        word: 'MÉARA',
        meaning: 'jdfksdjsl',
        number: 381
    },'2023-02-10': {
        word: 'FÍRIC',
        meaning: 'jdfksdjsl',
        number: 382
    },'2023-02-11': {
        word: 'BUAMA',
        meaning: 'jdfksdjsl',
        number: 383
    },'2023-02-12': {
        word: 'BAIST',
        meaning: 'jdfksdjsl',
        number: 384
    },'2023-02-13': {
        word: 'CRIOS',
        meaning: 'jdfksdjsl',
        number: 385
    },'2023-02-14': {
        word: 'LEAID',
        meaning: 'jdfksdjsl',
        number: 386
    },'2023-02-15': {
        word: 'MEATH',
        meaning: 'jdfksdjsl',
        number: 387
    },'2023-02-16': {
        word: 'AOSTA',
        meaning: 'jdfksdjsl',
        number: 388
    },'2023-02-17': {
        word: 'SEILG',
        meaning: 'jdfksdjsl',
        number: 389
    },'2023-02-18': {
        word: 'GOILL',
        meaning: 'jdfksdjsl',
        number: 390
    },'2023-02-19': {
        word: 'SÉIMH',
        meaning: 'jdfksdjsl',
        number: 391
    },'2023-02-20': {
        word: 'SCÍTH',
        meaning: 'jdfksdjsl',
        number: 392
    },'2023-02-21': {
        word: 'PUINN',
        meaning: 'jdfksdjsl',
        number: 393
    },'2023-02-22': {
        word: 'RIALÚ',
        meaning: 'jdfksdjsl',
        number: 394
    },'2023-02-23': {
        word: 'GADAÍ',
        meaning: 'jdfksdjsl',
        number: 395
    },'2023-02-24': {
        word: 'MAISE',
        meaning: 'jdfksdjsl',
        number: 396
    },'2023-02-25': {
        word: 'IMIRT',
        meaning: 'jdfksdjsl',
        number: 397
    },'2023-02-26': {
        word: 'OCHTÓ',
        meaning: 'jdfksdjsl',
        number: 398
    },'2023-02-27': {
        word: 'CRAIC',
        meaning: 'jdfksdjsl',
        number: 399
    },'2023-02-28': {
        word: 'OLANN',
        meaning: 'jdfksdjsl',
        number: 400
    },'2023-03-01': {
        word: 'SÚIGH',
        meaning: 'jdfksdjsl',
        number: 401
    },'2023-03-02': {
        word: 'DOCHT',
        meaning: 'jdfksdjsl',
        number: 402
    },'2023-03-03': {
        word: 'AILSE',
        meaning: 'jdfksdjsl',
        number: 403
    },'2023-03-04': {
        word: 'faire',
        meaning: 'jdfksdjsl',
        number: 404
    },'2023-03-05': {
        word: 'caoch',
        meaning: 'jdfksdjsl',
        number: 405
    },'2023-03-06': {
        word: 'síoda',
        meaning: 'jdfksdjsl',
        number: 406
    },'2023-03-07': {
        word: 'eadar',
        meaning: 'jdfksdjsl',
        number: 407
    },'2023-03-08': {
        word: 'cumha',
        meaning: 'jdfksdjsl',
        number: 408
    },'2023-03-09': {
        word: 'caife',
        meaning: 'jdfksdjsl',
        number: 409
    },'2023-03-10': {
        word: 'sáith',
        meaning: 'jdfksdjsl',
        number: 410
    },'2023-03-11': {
        word: 'ráfla',
        meaning: 'jdfksdjsl',
        number: 411
    },'2023-03-12': {
        word: 'cuach',
        meaning: 'jdfksdjsl',
        number: 412
    },'2023-03-13': {
        word: 'airne',
        meaning: 'jdfksdjsl',
        number: 413
    },'2023-03-14': {
        word: 'luibh',
        meaning: 'jdfksdjsl',
        number: 414
    },'2023-03-15': {
        word: 'tnúth',
        meaning: 'jdfksdjsl',
        number: 415
    },'2023-03-16': {
        word: 'cearr',
        meaning: 'jdfksdjsl',
        number: 416
    },'2023-03-17': {
        word: 'beach',
        meaning: 'jdfksdjsl',
        number: 417
    },'2023-03-18': {
        word: 'éindí',
        meaning: 'jdfksdjsl',
        number: 418
    },'2023-03-19': {
        word: 'anoir',
        meaning: 'jdfksdjsl',
        number: 419
    },'2023-03-20': {
        word: 'sciar',
        meaning: 'jdfksdjsl',
        number: 420
    },'2023-03-21': {
        word: 'plána',
        meaning: 'jdfksdjsl',
        number: 421
    },'2023-03-22': {
        word: 'beola',
        meaning: 'jdfksdjsl',
        number: 422
    },'2023-03-23': {
        word: 'creat',
        meaning: 'jdfksdjsl',
        number: 423
    },'2023-03-24': {
        word: 'cróga',
        meaning: 'jdfksdjsl',
        number: 424
    },'2023-03-25': {
        word: 'mothú',
        meaning: 'jdfksdjsl',
        number: 425
    },'2023-03-26': {
        word: 'aoibh',
        meaning: 'jdfksdjsl',
        number: 426
    },'2023-03-27': {
        word: 'sicín',
        meaning: 'jdfksdjsl',
        number: 427
    },'2023-03-28': {
        word: 'bearr',
        meaning: 'jdfksdjsl',
        number: 428
    },'2023-03-29': {
        word: 'féith',
        meaning: 'jdfksdjsl',
        number: 429
    },'2023-03-30': {
        word: 'ortha',
        meaning: 'jdfksdjsl',
        number: 430
    },'2023-03-31': {
        word: 'forás',
        meaning: 'jdfksdjsl',
        number: 431
    },'2023-04-01': {
        word: 'masla',
        meaning: 'jdfksdjsl',
        number: 432
    },'2023-04-02': {
        word: 'cónra',
        meaning: 'jdfksdjsl',
        number: 433
    },'2023-04-03': {
        word: 'trian',
        meaning: 'jdfksdjsl',
        number: 434
    },'2023-04-04': {
        word: 'dhein',
        meaning: 'jdfksdjsl',
        number: 435
    },'2023-04-05': {
        word: 'tosaí',
        meaning: 'jdfksdjsl',
        number: 436
    },'2023-04-06': {
        word: 'staon',
        meaning: 'jdfksdjsl',
        number: 437
    },'2023-04-07': {
        word: 'goile',
        meaning: 'jdfksdjsl',
        number: 438
    },'2023-04-08': {
        word: 'tuama',
        meaning: 'jdfksdjsl',
        number: 439
    },'2023-04-09': {
        word: 'uacht',
        meaning: 'jdfksdjsl',
        number: 440
    },'2023-04-10': {
        word: 'peata',
        meaning: 'jdfksdjsl',
        number: 441
    },'2023-04-11': {
        word: 'laige',
        meaning: 'jdfksdjsl',
        number: 442
    },'2023-04-12': {
        word: 'stoca',
        meaning: 'jdfksdjsl',
        number: 443
    },'2023-04-13': {
        word: 'DRAOI',
        meaning: 'jdfksdjsl',
        number: 444
    },'2023-04-14': {
        word: 'BEANN',
        meaning: 'jdfksdjsl',
        number: 445
    },'2023-04-15': {
        word: 'GLÓIR',
        meaning: 'jdfksdjsl',
        number: 446
    },'2023-04-16': {
        word: 'TEILG',
        meaning: 'jdfksdjsl',
        number: 447
    },'2023-04-17': {
        word: 'PÉIST',
        meaning: 'jdfksdjsl',
        number: 448
    },'2023-04-18': {
        word: 'LUASC',
        meaning: 'jdfksdjsl',
        number: 449
    },'2023-04-19': {
        word: 'CATHÚ',
        meaning: 'jdfksdjsl',
        number: 450
    },'2023-04-20': {
        word: 'SÉALA',
        meaning: 'jdfksdjsl',
        number: 451
    },'2023-04-21': {
        word: 'RACHT',
        meaning: 'jdfksdjsl',
        number: 452
    },'2023-04-22': {
        word: 'ÍDIGH',
        meaning: 'jdfksdjsl',
        number: 453
    },'2023-04-23': {
        word: 'SNÁTH',
        meaning: 'jdfksdjsl',
        number: 454
    },'2023-04-24': {
        word: 'UAIMH',
        meaning: 'jdfksdjsl',
        number: 455
    },'2023-04-25': {
        word: 'CASÓG',
        meaning: 'jdfksdjsl',
        number: 456
    },'2023-04-26': {
        word: 'OILTE',
        meaning: 'jdfksdjsl',
        number: 457
    },'2023-04-27': {
        word: 'SMIOR',
        meaning: 'jdfksdjsl',
        number: 458
    },'2023-04-28': {
        word: 'CÚISÍ',
        meaning: 'jdfksdjsl',
        number: 459
    },'2023-04-29': {
        word: 'CÍSTE',
        meaning: 'jdfksdjsl',
        number: 460
    },'2023-04-30': {
        word: 'TARLÚ',
        meaning: 'jdfksdjsl',
        number: 461
    },'2023-05-01': {
        word: 'BALBH',
        meaning: 'jdfksdjsl',
        number: 462
    },'2023-05-02': {
        word: 'COTHÚ',
        meaning: 'jdfksdjsl',
        number: 463
    },'2023-05-03': {
        word: 'PÚDAR',
        meaning: 'jdfksdjsl',
        number: 464
    },'2023-05-04': {
        word: 'SONAS',
        meaning: 'jdfksdjsl',
        number: 465
    },'2023-05-05': {
        word: 'SEIFT',
        meaning: 'jdfksdjsl',
        number: 466
    },'2023-05-06': {
        word: 'BEOIR',
        meaning: 'jdfksdjsl',
        number: 467
    },'2023-05-07': {
        word: 'LAMPA',
        meaning: 'jdfksdjsl',
        number: 468
    },'2023-05-08': {
        word: 'CAIFÉ',
        meaning: 'jdfksdjsl',
        number: 469
    },'2023-05-09': {
        word: 'STRAE',
        meaning: 'jdfksdjsl',
        number: 470
    },'2023-05-10': {
        word: 'MAMAÍ',
        meaning: 'jdfksdjsl',
        number: 471
    },'2023-05-11': {
        word: 'UMHAL',
        meaning: 'jdfksdjsl',
        number: 472
    },'2023-05-12': {
        word: 'MIONN',
        meaning: 'jdfksdjsl',
        number: 473
    },'2023-05-13': {
        word: 'CÍOCH',
        meaning: 'jdfksdjsl',
        number: 474
    },'2023-05-14': {
        word: 'COISC',
        meaning: 'jdfksdjsl',
        number: 475
    },'2023-05-15': {
        word: 'TUATA',
        meaning: 'jdfksdjsl',
        number: 476
    },'2023-05-16': {
        word: 'TÉAMH',
        meaning: 'jdfksdjsl',
        number: 477
    },'2023-05-17': {
        word: 'DREAP',
        meaning: 'jdfksdjsl',
        number: 478
    },'2023-05-18': {
        word: 'UATHA',
        meaning: 'jdfksdjsl',
        number: 479
    },'2023-05-19': {
        word: 'SEILF',
        meaning: 'jdfksdjsl',
        number: 480
    },'2023-05-20': {
        word: 'LEOGA',
        meaning: 'jdfksdjsl',
        number: 481
    },'2023-05-21': {
        word: 'NÓCHA',
        meaning: 'jdfksdjsl',
        number: 482
    },'2023-05-22': {
        word: 'GONTA',
        meaning: 'jdfksdjsl',
        number: 483
    },'2023-05-23': {
        word: 'IOMRÁ',
        meaning: 'jdfksdjsl',
        number: 484
    },'2023-05-24': {
        word: 'DREAS',
        meaning: 'jdfksdjsl',
        number: 485
    },'2023-05-25': {
        word: 'DÍOBH',
        meaning: 'jdfksdjsl',
        number: 486
    },'2023-05-26': {
        word: 'GREAD',
        meaning: 'jdfksdjsl',
        number: 487
    },'2023-05-27': {
        word: 'LEANN',
        meaning: 'jdfksdjsl',
        number: 488
    },'2023-05-28': {
        word: 'OLCAS',
        meaning: 'jdfksdjsl',
        number: 489
    },'2023-05-29': {
        word: 'URNAÍ',
        meaning: 'jdfksdjsl',
        number: 490
    },'2023-05-30': {
        word: 'GORTÚ',
        meaning: 'jdfksdjsl',
        number: 491
    },'2023-05-31': {
        word: 'CEARN',
        meaning: 'jdfksdjsl',
        number: 492
    },'2023-06-01': {
        word: 'IOLRA',
        meaning: 'jdfksdjsl',
        number: 493
    },'2023-06-02': {
        word: 'GNÚIS',
        meaning: 'jdfksdjsl',
        number: 494
    },'2023-06-03': {
        word: 'PÉINT',
        meaning: 'jdfksdjsl',
        number: 495
    },'2023-06-04': {
        word: 'STAIC',
        meaning: 'jdfksdjsl',
        number: 496
    },'2023-06-05': {
        word: 'TOCHT',
        meaning: 'jdfksdjsl',
        number: 497
    },'2023-06-06': {
        word: 'FOSTÚ',
        meaning: 'jdfksdjsl',
        number: 498
    },'2023-06-07': {
        word: 'LEAMH',
        meaning: 'jdfksdjsl',
        number: 499
    },'2023-06-08': {
        word: 'DÓITE',
        meaning: 'jdfksdjsl',
        number: 500
    },'2023-06-09': {
        word: 'TOISE',
        meaning: 'jdfksdjsl',
        number: 501
    },'2023-06-10': {
        word: 'DAIDÍ',
        meaning: 'jdfksdjsl',
        number: 502
    },'2023-06-11': {
        word: 'GEALT',
        meaning: 'jdfksdjsl',
        number: 503
    },'2023-06-12': {
        word: 'TONNA',
        meaning: 'jdfksdjsl',
        number: 504
    },'2023-06-13': {
        word: 'FOCLA',
        meaning: 'jdfksdjsl',
        number: 505
    },'2023-06-14': {
        word: 'GREAN',
        meaning: 'jdfksdjsl',
        number: 506
    },'2023-06-15': {
        word: 'AOIRE',
        meaning: 'jdfksdjsl',
        number: 507
    },'2023-06-16': {
        word: 'NÉATA',
        meaning: 'jdfksdjsl',
        number: 508
    },'2023-06-17': {
        word: 'ORDÓG',
        meaning: 'jdfksdjsl',
        number: 509
    },'2023-06-18': {
        word: 'LIOPA',
        meaning: 'jdfksdjsl',
        number: 510
    },'2023-06-19': {
        word: 'FINNE',
        meaning: 'jdfksdjsl',
        number: 511
    },'2023-06-20': {
        word: 'ÚRNUA',
        meaning: 'jdfksdjsl',
        number: 512
    },'2023-06-21': {
        word: 'TRÉAD',
        meaning: 'jdfksdjsl',
        number: 513
    },'2023-06-22': {
        word: 'CÉIMÍ',
        meaning: 'jdfksdjsl',
        number: 514
    },'2023-06-23': {
        word: 'CREIM',
        meaning: 'jdfksdjsl',
        number: 515
    },'2023-06-24': {
        word: 'SPOTA',
        meaning: 'jdfksdjsl',
        number: 516
    },'2023-06-25': {
        word: 'DONAS',
        meaning: 'jdfksdjsl',
        number: 517
    },'2023-06-26': {
        word: 'CAMÁN',
        meaning: 'jdfksdjsl',
        number: 518
    },'2023-06-27': {
        word: 'LEOMH',
        meaning: 'jdfksdjsl',
        number: 519
    },'2023-06-28': {
        word: 'CHÓIR',
        meaning: 'jdfksdjsl',
        number: 520
    },'2023-06-29': {
        word: 'CIPÍN',
        meaning: 'jdfksdjsl',
        number: 521
    },'2023-06-30': {
        word: 'SAILL',
        meaning: 'jdfksdjsl',
        number: 522
    },'2023-07-01': {
        word: 'FÓCAS',
        meaning: 'jdfksdjsl',
        number: 523
    },'2023-07-02': {
        word: 'CÓFRA',
        meaning: 'jdfksdjsl',
        number: 524
    },'2023-07-03': {
        word: 'PÁLÁS',
        meaning: 'jdfksdjsl',
        number: 525
    },'2023-07-04': {
        word: 'CLAIS',
        meaning: 'jdfksdjsl',
        number: 526
    },'2023-07-05': {
        word: 'SLIOS',
        meaning: 'jdfksdjsl',
        number: 527
    },'2023-07-06': {
        word: 'FÓNTA',
        meaning: 'jdfksdjsl',
        number: 528
    },'2023-07-07': {
        word: 'AICÍD',
        meaning: 'jdfksdjsl',
        number: 529
    },'2023-07-08': {
        word: 'STUIF',
        meaning: 'jdfksdjsl',
        number: 530
    },'2023-07-09': {
        word: 'GIALL',
        meaning: 'jdfksdjsl',
        number: 531
    },'2023-07-10': {
        word: 'COIRE',
        meaning: 'jdfksdjsl',
        number: 532
    },'2023-07-11': {
        word: 'GRÁIN',
        meaning: 'jdfksdjsl',
        number: 533
    },'2023-07-12': {
        word: 'BÁÚIL',
        meaning: 'jdfksdjsl',
        number: 534
    },'2023-07-13': {
        word: 'SODAR',
        meaning: 'jdfksdjsl',
        number: 535
    },'2023-07-14': {
        word: 'MODÚL',
        meaning: 'jdfksdjsl',
        number: 536
    },'2023-07-15': {
        word: 'DEASC',
        meaning: 'jdfksdjsl',
        number: 537
    },'2023-07-16': {
        word: 'DEOIN',
        meaning: 'jdfksdjsl',
        number: 538
    },'2023-07-17': {
        word: 'UAINE',
        meaning: 'jdfksdjsl',
        number: 539
    },'2023-07-18': {
        word: 'BUAIC',
        meaning: 'jdfksdjsl',
        number: 540
    },'2023-07-19': {
        word: 'ÉIGSE',
        meaning: 'jdfksdjsl',
        number: 541
    },'2023-07-20': {
        word: 'PUTÓG',
        meaning: 'jdfksdjsl',
        number: 542
    },'2023-07-21': {
        word: 'LOISC',
        meaning: 'jdfksdjsl',
        number: 543
    },'2023-07-22': {
        word: 'LÍOMH',
        meaning: 'jdfksdjsl',
        number: 544
    },'2023-07-23': {
        word: 'ANEAS',
        meaning: 'jdfksdjsl',
        number: 545
    },'2023-07-24': {
        word: 'CLÁRÚ',
        meaning: 'jdfksdjsl',
        number: 546
    },'2023-07-25': {
        word: 'SEOID',
        meaning: 'jdfksdjsl',
        number: 547
    },'2023-07-26': {
        word: 'DAOFA',
        meaning: 'jdfksdjsl',
        number: 548
    },'2023-07-27': {
        word: 'FÁSRA',
        meaning: 'jdfksdjsl',
        number: 549
    },'2023-07-28': {
        word: 'DRUMA',
        meaning: 'jdfksdjsl',
        number: 550
    },'2023-07-29': {
        word: 'IONGA',
        meaning: 'jdfksdjsl',
        number: 551
    },'2023-07-30': {
        word: 'BOGHA',
        meaning: 'jdfksdjsl',
        number: 552
    },'2023-07-31': {
        word: 'TRÁTA',
        meaning: 'jdfksdjsl',
        number: 553
    },'2023-08-01': {
        word: 'BACÁN',
        meaning: 'jdfksdjsl',
        number: 554
    },'2023-08-02': {
        word: 'TACAR',
        meaning: 'jdfksdjsl',
        number: 555
    },'2023-08-03': {
        word: 'CASÚR',
        meaning: 'jdfksdjsl',
        number: 556
    },'2023-08-04': {
        word: 'ROLLA',
        meaning: 'jdfksdjsl',
        number: 557
    },'2023-08-05': {
        word: 'LEASC',
        meaning: 'jdfksdjsl',
        number: 558
    },'2023-08-06': {
        word: 'LÍOFA',
        meaning: 'jdfksdjsl',
        number: 559
    },'2023-08-07': {
        word: 'TARLÚ',
        meaning: 'jdfksdjsl',
        number: 560
    },'2023-08-08': {
        word: 'GRÉAS',
        meaning: 'jdfksdjsl',
        number: 561
    },'2023-08-09': {
        word: 'SLÁNÚ',
        meaning: 'jdfksdjsl',
        number: 562
    },'2023-08-10': {
        word: 'PLÚCH',
        meaning: 'jdfksdjsl',
        number: 563
    },'2023-08-11': {
        word: 'DEALG',
        meaning: 'jdfksdjsl',
        number: 564
    },'2023-08-12': {
        word: 'PREAS',
        meaning: 'jdfksdjsl',
        number: 565
    },'2023-08-13': {
        word: 'CUING',
        meaning: 'jdfksdjsl',
        number: 566
    },'2023-08-14': {
        word: 'CORCA',
        meaning: 'jdfksdjsl',
        number: 567
    },'2023-08-15': {
        word: 'IOLAR',
        meaning: 'jdfksdjsl',
        number: 568
    },'2023-08-16': {
        word: 'ARANN',
        meaning: 'jdfksdjsl',
        number: 569
    },'2023-08-17': {
        word: 'DRÉIM',
        meaning: 'jdfksdjsl',
        number: 570
    },'2023-08-18': {
        word: 'TEIBÍ',
        meaning: 'jdfksdjsl',
        number: 571
    },'2023-08-19': {
        word: 'PRIOC',
        meaning: 'jdfksdjsl',
        number: 572
    },'2023-08-20': {
        word: 'SMÉAR',
        meaning: 'jdfksdjsl',
        number: 573
    },'2023-08-21': {
        word: 'GOTHA',
        meaning: 'jdfksdjsl',
        number: 574
    },'2023-08-22': {
        word: 'PLUID',
        meaning: 'jdfksdjsl',
        number: 575
    },'2023-08-23': {
        word: 'COLÚR',
        meaning: 'jdfksdjsl',
        number: 576
    },'2023-08-24': {
        word: 'DÁIMH',
        meaning: 'jdfksdjsl',
        number: 577
    },'2023-08-25': {
        word: 'SÍNIÚ',
        meaning: 'jdfksdjsl',
        number: 578
    },'2023-08-26': {
        word: 'LIONN',
        meaning: 'jdfksdjsl',
        number: 579
    },'2023-08-27': {
        word: 'FÁIDH',
        meaning: 'jdfksdjsl',
        number: 580
    },'2023-08-28': {
        word: 'ATHRÁ',
        meaning: 'jdfksdjsl',
        number: 581
    },'2023-08-29': {
        word: 'FRÁSA',
        meaning: 'jdfksdjsl',
        number: 582
    },'2023-08-30': {
        word: 'GOIRT',
        meaning: 'jdfksdjsl',
        number: 583
    },'2023-08-31': {
        word: 'MÉITH',
        meaning: 'jdfksdjsl',
        number: 584
    },'2023-09-01': {
        word: 'ORGÁN',
        meaning: 'jdfksdjsl',
        number: 585
    },'2023-09-02': {
        word: 'MATÁN',
        meaning: 'jdfksdjsl',
        number: 586
    },'2023-09-03': {
        word: 'GABHA',
        meaning: 'jdfksdjsl',
        number: 587
    },'2023-09-04': {
        word: 'BÁBÓG',
        meaning: 'jdfksdjsl',
        number: 588
    },'2023-09-05': {
        word: 'CÁBÁN',
        meaning: 'jdfksdjsl',
        number: 589
    },'2023-09-06': {
        word: 'TARLÚ',
        meaning: 'jdfksdjsl',
        number: 590
    },'2023-09-07': {
        word: 'TAISC',
        meaning: 'jdfksdjsl',
        number: 591
    },'2023-09-08': {
        word: 'TARNA',
        meaning: 'jdfksdjsl',
        number: 592
    },'2023-09-09': {
        word: 'AGAIR',
        meaning: 'jdfksdjsl',
        number: 593
    },'2023-09-10': {
        word: 'FOLÚS',
        meaning: 'jdfksdjsl',
        number: 594
    },'2023-09-11': {
        word: 'RIBÍN',
        meaning: 'jdfksdjsl',
        number: 595
    },'2023-09-12': {
        word: 'SÚGÁN',
        meaning: 'jdfksdjsl',
        number: 596
    },'2023-09-13': {
        word: 'BANBH',
        meaning: 'jdfksdjsl',
        number: 597
    },'2023-09-14': {
        word: 'CNEAS',
        meaning: 'jdfksdjsl',
        number: 598
    },'2023-09-15': {
        word: 'LEACA',
        meaning: 'jdfksdjsl',
        number: 599
    },'2023-09-16': {
        word: 'THOIR',
        meaning: 'jdfksdjsl',
        number: 600
    },'2023-09-17': {
        word: 'EAGAL',
        meaning: 'jdfksdjsl',
        number: 601
    },'2023-09-18': {
        word: 'CRUAS',
        meaning: 'jdfksdjsl',
        number: 602
    },'2023-09-19': {
        word: 'CRAOS',
        meaning: 'jdfksdjsl',
        number: 603
    },'2023-09-20': {
        word: 'FAIDE',
        meaning: 'jdfksdjsl',
        number: 604
    },'2023-09-21': {
        word: 'PLAIC',
        meaning: 'jdfksdjsl',
        number: 605
    },'2023-09-22': {
        word: 'CAILC',
        meaning: 'jdfksdjsl',
        number: 606
    },'2023-09-23': {
        word: 'CORDA',
        meaning: 'jdfksdjsl',
        number: 607
    },'2023-09-24': {
        word: 'SEODA',
        meaning: 'jdfksdjsl',
        number: 608
    },'2023-09-25': {
        word: 'CRUIT',
        meaning: 'jdfksdjsl',
        number: 609
    },'2023-09-26': {
        word: 'SMEAR',
        meaning: 'jdfksdjsl',
        number: 610
    },'2023-09-27': {
        word: 'MÓTAR',
        meaning: 'jdfksdjsl',
        number: 611
    },'2023-09-28': {
        word: 'FIDIL',
        meaning: 'jdfksdjsl',
        number: 612
    },'2023-09-29': {
        word: 'PLOTA',
        meaning: 'jdfksdjsl',
        number: 613
    },'2023-09-30': {
        word: 'SÁINN',
        meaning: 'jdfksdjsl',
        number: 614
    },'2023-10-01': {
        word: 'CREIG',
        meaning: 'jdfksdjsl',
        number: 615
    },'2023-10-02': {
        word: 'CÁBLA',
        meaning: 'jdfksdjsl',
        number: 616
    },'2023-10-03': {
        word: 'TEORA',
        meaning: 'jdfksdjsl',
        number: 617
    },'2023-10-04': {
        word: 'IARLA',
        meaning: 'jdfksdjsl',
        number: 618
    },'2023-10-05': {
        word: 'PÉINE',
        meaning: 'jdfksdjsl',
        number: 619
    },'2023-10-06': {
        word: 'LAGAR',
        meaning: 'jdfksdjsl',
        number: 620
    },'2023-10-07': {
        word: 'FEANN',
        meaning: 'jdfksdjsl',
        number: 621
    },'2023-10-08': {
        word: 'DEILF',
        meaning: 'jdfksdjsl',
        number: 622
    },'2023-10-09': {
        word: 'MACHA',
        meaning: 'jdfksdjsl',
        number: 623
    },'2023-10-10': {
        word: 'BANDA',
        meaning: 'jdfksdjsl',
        number: 624
    },'2023-10-11': {
        word: 'SMÚIT',
        meaning: 'jdfksdjsl',
        number: 625
    },'2023-10-12': {
        word: 'BRÍCE',
        meaning: 'jdfksdjsl',
        number: 626
    },'2023-10-13': {
        word: 'BAGÚN',
        meaning: 'jdfksdjsl',
        number: 627
    },'2023-10-14': {
        word: 'GAOIS',
        meaning: 'jdfksdjsl',
        number: 628
    },'2023-10-15': {
        word: 'SEASC',
        meaning: 'jdfksdjsl',
        number: 629
    },'2023-10-16': {
        word: 'DARNA',
        meaning: 'jdfksdjsl',
        number: 630
    },'2023-10-17': {
        word: 'SCINN',
        meaning: 'jdfksdjsl',
        number: 631
    },'2023-10-18': {
        word: 'LASTA',
        meaning: 'jdfksdjsl',
        number: 632
    },'2023-10-19': {
        word: 'ÁIRSE',
        meaning: 'jdfksdjsl',
        number: 633
    },'2023-10-20': {
        word: 'EASNA',
        meaning: 'jdfksdjsl',
        number: 634
    },'2023-10-21': {
        word: 'RIASC',
        meaning: 'jdfksdjsl',
        number: 635
    },'2023-10-22': {
        word: 'PUNTA',
        meaning: 'jdfksdjsl',
        number: 636
    },'2023-10-23': {
        word: 'ACLAÍ',
        meaning: 'jdfksdjsl',
        number: 637
    },'2023-10-24': {
        word: 'COIRT',
        meaning: 'jdfksdjsl',
        number: 638
    },'2023-10-25': {
        word: 'CUNTA',
        meaning: 'jdfksdjsl',
        number: 639
    },'2023-10-26': {
        word: 'TACAÍ',
        meaning: 'jdfksdjsl',
        number: 640
    },'2023-10-27': {
        word: 'TREIS',
        meaning: 'jdfksdjsl',
        number: 641
    },'2023-10-28': {
        word: 'SCEAN',
        meaning: 'jdfksdjsl',
        number: 642
    },'2023-10-29': {
        word: 'TRÚPA',
        meaning: 'jdfksdjsl',
        number: 643
    },'2023-10-30': {
        word: 'GOBÁN',
        meaning: 'jdfksdjsl',
        number: 644
    },'2023-10-31': {
        word: 'CÉILÍ',
        meaning: 'jdfksdjsl',
        number: 645
    },'2023-11-01': {
        word: 'FOGHA',
        meaning: 'jdfksdjsl',
        number: 646
    },'2023-11-02': {
        word: 'SPOCH',
        meaning: 'jdfksdjsl',
        number: 647
    },'2023-11-03': {
        word: 'CASLA',
        meaning: 'jdfksdjsl',
        number: 648
    },'2023-11-04': {
        word: 'ISPÍN',
        meaning: 'jdfksdjsl',
        number: 649
    },'2023-11-05': {
        word: 'BABAÍ',
        meaning: 'jdfksdjsl',
        number: 650
    },'2023-11-06': {
        word: 'FEART',
        meaning: 'jdfksdjsl',
        number: 651
    },'2023-11-07': {
        word: 'TREAS',
        meaning: 'jdfksdjsl',
        number: 652
    },'2023-11-08': {
        word: 'FISIC',
        meaning: 'jdfksdjsl',
        number: 653
    },'2023-11-09': {
        word: 'SCALL',
        meaning: 'jdfksdjsl',
        number: 654
    },'2023-11-10': {
        word: 'ÍSLIÚ',
        meaning: 'jdfksdjsl',
        number: 655
    },'2023-11-11': {
        word: 'MEIRG',
        meaning: 'jdfksdjsl',
        number: 656
    },'2023-11-12': {
        word: 'LIRIC',
        meaning: 'jdfksdjsl',
        number: 657
    },'2023-11-13': {
        word: 'SEANG',
        meaning: 'jdfksdjsl',
        number: 658
    },'2023-11-14': {
        word: 'FRÍTH',
        meaning: 'jdfksdjsl',
        number: 659
    },'2023-11-15': {
        word: 'CEALG',
        meaning: 'jdfksdjsl',
        number: 660
    },'2023-11-16': {
        word: 'TROSC',
        meaning: 'jdfksdjsl',
        number: 661
    },'2023-11-17': {
        word: 'FAOMH',
        meaning: 'jdfksdjsl',
        number: 662
    },'2023-11-18': {
        word: 'LEICE',
        meaning: 'jdfksdjsl',
        number: 663
    },'2023-11-19': {
        word: 'OCHTÚ',
        meaning: 'jdfksdjsl',
        number: 664
    },'2023-11-20': {
        word: 'DÓLÁS',
        meaning: 'jdfksdjsl',
        number: 665
    },'2023-11-21': {
        word: 'SCEON',
        meaning: 'jdfksdjsl',
        number: 666
    },'2023-11-22': {
        word: 'TAOSC',
        meaning: 'jdfksdjsl',
        number: 667
    },'2023-11-23': {
        word: 'SOBAL',
        meaning: 'jdfksdjsl',
        number: 668
    },'2023-11-24': {
        word: 'MÁNLA',
        meaning: 'jdfksdjsl',
        number: 669
    },'2023-11-25': {
        word: 'DÉINE',
        meaning: 'jdfksdjsl',
        number: 670
    },'2023-11-26': {
        word: 'PRÓIS',
        meaning: 'jdfksdjsl',
        number: 671
    },'2023-11-27': {
        word: 'TEARC',
        meaning: 'jdfksdjsl',
        number: 672
    },'2023-11-28': {
        word: 'EASÓG',
        meaning: 'jdfksdjsl',
        number: 673
    },'2023-11-29': {
        word: 'BAILÍ',
        meaning: 'jdfksdjsl',
        number: 674
    },'2023-11-30': {
        word: 'MARÓG',
        meaning: 'jdfksdjsl',
        number: 675
    },'2023-12-01': {
        word: 'SONRÚ',
        meaning: 'jdfksdjsl',
        number: 676
    },'2023-12-02': {
        word: 'MNAOI',
        meaning: 'jdfksdjsl',
        number: 677
    },'2023-12-03': {
        word: 'EITIC',
        meaning: 'jdfksdjsl',
        number: 678
    },'2023-12-04': {
        word: 'BÁITH',
        meaning: 'jdfksdjsl',
        number: 679
    },'2023-12-05': {
        word: 'LEITE',
        meaning: 'jdfksdjsl',
        number: 680
    },'2023-12-06': {
        word: 'BAOTH',
        meaning: 'jdfksdjsl',
        number: 681
    },'2023-12-07': {
        word: 'CURFÁ',
        meaning: 'jdfksdjsl',
        number: 682
    },'2023-12-08': {
        word: 'MÚNLÚ',
        meaning: 'jdfksdjsl',
        number: 683
    },'2023-12-09': {
        word: 'CRÍON',
        meaning: 'jdfksdjsl',
        number: 684
    },'2023-12-10': {
        word: 'FÍOCH',
        meaning: 'jdfksdjsl',
        number: 685
    },'2023-12-11': {
        word: 'BUACH',
        meaning: 'jdfksdjsl',
        number: 686
    },'2023-12-12': {
        word: 'CORNA',
        meaning: 'jdfksdjsl',
        number: 687
    },'2023-12-13': {
        word: 'BARDA',
        meaning: 'jdfksdjsl',
        number: 688
    },'2023-12-14': {
        word: 'SNIGH',
        meaning: 'jdfksdjsl',
        number: 689
    },'2023-12-15': {
        word: 'BEOGA',
        meaning: 'jdfksdjsl',
        number: 690
    },'2023-12-16': {
        word: 'FUÁIL',
        meaning: 'jdfksdjsl',
        number: 691
    },'2023-12-17': {
        word: 'CAMAS',
        meaning: 'jdfksdjsl',
        number: 692
    },'2023-12-18': {
        word: 'TÓRAÍ',
        meaning: 'jdfksdjsl',
        number: 693
    },'2023-12-19': {
        word: 'SPALP',
        meaning: 'jdfksdjsl',
        number: 694
    },'2023-12-20': {
        word: 'SEARG',
        meaning: 'jdfksdjsl',
        number: 695
    },'2023-12-21': {
        word: 'DRÚIS',
        meaning: 'jdfksdjsl',
        number: 696
    },'2023-12-22': {
        word: 'OIBIR',
        meaning: 'jdfksdjsl',
        number: 697
    },'2023-12-23': {
        word: 'FALSA',
        meaning: 'jdfksdjsl',
        number: 698
    },'2023-12-24': {
        word: 'TRÉAS',
        meaning: 'jdfksdjsl',
        number: 699
    },'2023-12-25': {
        word: 'OIDHE',
        meaning: 'jdfksdjsl',
        number: 700
    },'2023-12-26': {
        word: 'BAOIS',
        meaning: 'jdfksdjsl',
        number: 701
    },'2023-12-27': {
        word: 'GAIBH',
        meaning: 'jdfksdjsl',
        number: 702
    },'2023-12-28': {
        word: 'GUAIM',
        meaning: 'jdfksdjsl',
        number: 703
    },'2023-12-29': {
        word: 'STÁIR',
        meaning: 'jdfksdjsl',
        number: 704
    },'2023-12-30': {
        word: 'IOMPÚ',
        meaning: 'jdfksdjsl',
        number: 705
    },'2023-12-31': {
        word: 'BOIGE',
        meaning: 'jdfksdjsl',
        number: 706
    },'2024-01-01': {
        word: 'DOIRE',
        meaning: 'jdfksdjsl',
        number: 707
    },'2024-01-02': {
        word: 'DALBA',
        meaning: 'jdfksdjsl',
        number: 708
    },'2024-01-03': {
        word: 'SEARC',
        meaning: 'jdfksdjsl',
        number: 709
    },'2024-01-04': {
        word: 'CASÁN',
        meaning: 'jdfksdjsl',
        number: 710
    },'2024-01-05': {
        word: 'TOILL',
        meaning: 'jdfksdjsl',
        number: 711
    },'2024-01-06': {
        word: 'TRUNC',
        meaning: 'jdfksdjsl',
        number: 712
    },'2024-01-07': {
        word: 'CUMAR',
        meaning: 'jdfksdjsl',
        number: 713
    },
    '2024-01-08': {
        word: 'ANÁLÚ',
        meaning: 'jdfksdjsl',
        number: 714
    },
    '2024-01-09': {
        word: 'SCÁIN',
        meaning: 'jdfksdjsl',
        number: 715
    },
    '2024-01-10': {
        word: 'SCINE',
        meaning: 'jdfksdjsl',
        number: 716
    },
    '2024-01-11': {
        word: 'CUILT',
        meaning: 'jdfksdjsl',
        number: 717
    },
    '2024-01-12': {
        word: 'MUIRÍ',
        meaning: 'jdfksdjsl',
        number: 718
    },
    '2024-01-13': {
        word: 'TRÚIG',
        meaning: 'jdfksdjsl',
        number: 719
    },
    '2024-01-14': {
        word: 'LACHT',
        meaning: 'jdfksdjsl',
        number: 720
    },
    '2024-01-15': {
        word: 'CÁITH',
        meaning: 'jdfksdjsl',
        number: 721
    },
    '2024-01-16': {
        word: 'SOTAL',
        meaning: 'jdfksdjsl',
        number: 721
    },
    '2024-01-17': {
        word: 'TEACH',
        meaning: 'jdfksdjsl',
        number: 722
    },
    '2024-01-18': {
        word: 'MÚISC',
        meaning: 'jdfksdjsl',
        number: 723
    },
    '2024-01-19': {
        word: 'CURAÍ',
        meaning: 'jdfksdjsl',
        number: 724
    },
    '2024-01-20': {
        word: 'BUIRG',
        meaning: 'jdfksdjsl',
        number: 725
    },
    '2024-01-21': {
        word: 'RACÁN',
        meaning: 'jdfksdjsl',
        number: 726
    },
    '2024-01-22': {
        word: 'LÉIMT',
        meaning: 'jdfksdjsl',
        number: 727
    },
    '2024-01-23': {
        word: 'BRÁCA',
        meaning: 'jdfksdjsl',
        number: 728
    },
    '2024-01-24': {
        word: 'STRÓC',
        meaning: 'jdfksdjsl',
        number: 729
    },
    '2024-01-25': {
        word: 'LÁBÁN',
        meaning: 'jdfksdjsl',
        number: 730
    },
    '2024-01-26': {
        word: 'COLPA',
        meaning: 'jdfksdjsl',
        number: 731
    },'2024-01-27': {
        word: 'OGHAM',
        meaning: 'jdfksdjsl',
        number: 732
    },'2024-01-28': {
        word: 'CALÓG',
        meaning: 'jdfksdjsl',
        number: 733
    },'2024-01-29': {
        word: 'CÉIDE',
        meaning: 'jdfksdjsl',
        number: 734
    },'2024-01-30': {
        word: 'DAMNÚ',
        meaning: 'jdfksdjsl',
        number: 735
    },'2024-01-31': {
        word: 'DLAOI',
        meaning: 'jdfksdjsl',
        number: 736
    },'2024-02-01': {
        word: 'EIPIC',
        meaning: 'jdfksdjsl',
        number: 737
    },'2024-02-02': {
        word: 'AIBÍD',
        meaning: 'jdfksdjsl',
        number: 738
    },'2024-02-03': {
        word: 'MOING',
        meaning: 'jdfksdjsl',
        number: 739
    },'2024-02-04': {
        word: 'LORGA',
        meaning: 'jdfksdjsl',
        number: 740
    },'2024-02-05': {
        word: 'BULLA',
        meaning: 'jdfksdjsl',
        number: 741
    },'2024-02-06': {
        word: 'STÁCA',
        meaning: 'jdfksdjsl',
        number: 742
    },'2024-02-07': {
        word: 'PAILM',
        meaning: 'jdfksdjsl',
        number: 743
    },'2024-02-08': {
        word: 'CAISE',
        meaning: 'jdfksdjsl',
        number: 744
    },'2024-02-09': {
        word: 'STIÚG',
        meaning: 'jdfksdjsl',
        number: 745
    },'2024-02-10': {
        word: 'POLLA',
        meaning: 'jdfksdjsl',
        number: 746
    },'2024-02-11': {
        word: 'SLEÁN',
        meaning: 'jdfksdjsl',
        number: 747
    },'2024-02-12': {
        word: 'MUINE',
        meaning: 'jdfksdjsl',
        number: 748
    },'2024-02-13': {
        word: 'FONSA',
        meaning: 'jdfksdjsl',
        number: 749
    },'2024-02-14': {
        word: 'PLUMA',
        meaning: 'jdfksdjsl',
        number: 750
    },'2024-02-15': {
        word: 'BÓLAÍ',
        meaning: 'jdfksdjsl',
        number: 751
    },'2024-02-16': {
        word: 'TEASC',
        meaning: 'jdfksdjsl',
        number: 752
    },'2024-02-17': {
        word: 'UASTA',
        meaning: 'jdfksdjsl',
        number: 753
    },'2024-02-18': {
        word: 'DÍLSE',
        meaning: 'jdfksdjsl',
        number: 754
    },'2024-02-19': {
        word: 'DUINE',
        meaning: 'jdfksdjsl',
        number: 755
    },'2024-02-20': {
        word: 'ABAIR',
        meaning: 'jdfksdjsl',
        number: 756
    },'2024-02-21': {
        word: 'MAITH',
        meaning: 'jdfksdjsl',
        number: 757
    },'2024-02-22': {
        word: 'FAIGH',
        meaning: 'jdfksdjsl',
        number: 758
    },'2024-02-23': {
        word: 'TÉIGH',
        meaning: 'jdfksdjsl',
        number: 759
    },'2024-02-24': {
        word: 'NUAIR',
        meaning: 'jdfksdjsl',
        number: 760
    },'2024-02-25': {
        word: 'AMACH',
        meaning: 'jdfksdjsl',
        number: 761
    },'2024-02-26': {
        word: 'CEANN',
        meaning: 'jdfksdjsl',
        number: 762
    },'2024-02-27': {
        word: 'CAITH',
        meaning: 'jdfksdjsl',
        number: 763
    },'2024-02-28': {
        word: 'CHOMH',
        meaning: 'jdfksdjsl',
        number: 764
    },'2024-02-29': {
        word: 'CHUIG',
        meaning: 'jdfksdjsl',
        number: 765
    },'2024-03-01': {
        word: 'OBAIR',
        meaning: 'jdfksdjsl',
        number: 766
    },'2024-03-02': {
        word: 'TAOBH',
        meaning: 'jdfksdjsl',
        number: 767
    },'2024-03-03': {
        word: 'ANOIS',
        meaning: 'jdfksdjsl',
        number: 768
    },'2024-03-04': {
        word: 'CÉILE',
        meaning: 'jdfksdjsl',
        number: 769
    },'2024-03-05': {
        word: 'TEACH',
        meaning: 'jdfksdjsl',
        number: 770
    },'2024-03-06': {
        word: 'CEART',
        meaning: 'jdfksdjsl',
        number: 771
    },'2024-03-07': {
        word: 'ROIMH',
        meaning: 'jdfksdjsl',
        number: 772
    },'2024-03-08': {
        word: 'SCÉAL',
        meaning: 'jdfksdjsl',
        number: 773
    },'2024-03-09': {
        word: 'CEIST',
        meaning: 'jdfksdjsl',
        number: 774
    },'2024-03-10': {
        word: 'ANSIN',
        meaning: 'jdfksdjsl',
        number: 775
    },'2024-03-11': {
        word: 'DÓIGH',
        meaning: 'jdfksdjsl',
        number: 776
    }, '2024-03-12': {
        word: 'POBAL',
        meaning: 'jdfksdjsl',
        number: 777
    },'2024-03-13': {
        word: 'SCOIL',
        meaning: 'jdfksdjsl',
        number: 778
    },'2024-03-14': {
        word: 'ROINN',
        meaning: 'jdfksdjsl',
        number: 779
    },'2024-03-15': {
        word: 'ÚSÁID',
        meaning: 'jdfksdjsl',
        number: 780
    },'2024-03-16': {
        word: 'LEITH',
        meaning: 'jdfksdjsl',
        number: 781
    },'2024-03-17': {
        word: 'ANSEO',
        meaning: 'jdfksdjsl',
        number: 782
    },'2024-03-18': {
        word: 'OÍCHE',
        meaning: 'jdfksdjsl',
        number: 783
    }
    ,'2024-03-19': {
        word: 'BAILE',
        meaning: 'jdfksdjsl',
        number: 784
    }
    ,'2024-03-20': {
        word: 'LUCHT',
        meaning: 'jdfksdjsl',
        number: 785
    },'2024-03-21': {
        word: 'CÚRSA',
        meaning: 'jdfksdjsl',
        number: 786
    },'2024-03-22': {
        word: 'EOLAS',
        meaning: 'jdfksdjsl',
        number: 787
    },'2024-03-23': {
        word: 'LUCHT',
        meaning: 'jdfksdjsl',
        number: 788
    },'2024-03-24': {
        word: 'IMIGH',
        meaning: 'jdfksdjsl',
        number: 789
    },'2024-03-25': {
        word: 'CAINT',
        meaning: 'jdfksdjsl',
        number: 790
    },'2024-03-26': {
        word: 'ÁBHAR',
        meaning: 'jdfksdjsl',
        number: 791
    },'2024-03-27': {
        word: 'FÉACH',
        meaning: 'jdfksdjsl',
        number: 792
    },'2024-03-28': {
        word: 'SIÚIL',
        meaning: 'jdfksdjsl',
        number: 793
    },'2024-03-29': {
        word: 'ÉIGIN',
        meaning: 'jdfksdjsl',
        number: 794
    },'2024-03-30': {
        word: 'BUAIL',
        meaning: 'jdfksdjsl',
        number: 795
    },'2024-03-31': {
        word: 'RIAMH',
        meaning: 'jdfksdjsl',
        number: 796
    },'2024-04-01': {
        word: 'LUCHT',
        meaning: 'jdfksdjsl',
        number: 797
    },'2024-04-02': {
        word: 'CÚRSA',
        meaning: 'jdfksdjsl',
        number: 798
    },'2024-04-03': {
        word: 'EOLAS',
        meaning: 'jdfksdjsl',
        number: 799
    },'2024-04-04': {
        word: 'IMIGH',
        meaning: 'jdfksdjsl',
        number: 780
    },'2024-04-05': {
        word: 'CAINT',
        meaning: 'jdfksdjsl',
        number: 781
    },'2024-04-06': {
        word: 'PÁIRC',
        meaning: 'jdfksdjsl',
        number: 782
    },'2024-04-07': {
        word: 'LÉANN',
        meaning: 'jdfksdjsl',
        number: 783
    },'2024-04-08': {
        word: 'ROGHA',
        meaning: 'jdfksdjsl',
        number: 784
    },'2024-04-09': {
        word: 'LEATH',
        meaning: 'jdfksdjsl',
        number: 785
    },'2024-04-10': {
        word: 'FÉILE',
        meaning: 'jdfksdjsl',
        number: 786
    },'2024-04-11': {
        word: 'UASAL',
        meaning: 'jdfksdjsl',
        number: 787
    },'2024-04-12': {
        word: 'CONAS',
        meaning: 'jdfksdjsl',
        number: 788
    },'2024-04-13': {
        word: 'GRIAN',
        meaning: 'jdfksdjsl',
        number: 789
    },'2024-04-14': {
        word: 'DÓCHA',
        meaning: 'jdfksdjsl',
        number: 790
    },'2024-04-15': {
        word: 'PÍOSA',
        meaning: 'jdfksdjsl',
        number: 791
    },'2024-04-16': {
        word: 'CÓNAÍ',
        meaning: 'jdfksdjsl',
        number: 792
    },'2024-04-17': {
        word: 'THART',
        meaning: 'jdfksdjsl',
        number: 793
    },'2024-04-18': {
        word: 'MINIC',
        meaning: 'jdfksdjsl',
        number: 794
    },'2024-04-19': {
        word: 'ANUAS',
        meaning: 'jdfksdjsl',
        number: 795
    },'2024-04-20': {
        word: 'IONAD',
        meaning: 'jdfksdjsl',
        number: 796
    },'2024-04-21': {
        word: 'UISCE',
        meaning: 'jdfksdjsl',
        number: 797
    },'2024-04-22': {
        word: 'GEALL',
        meaning: 'jdfksdjsl',
        number: 798
    },'2024-04-23': {
        word: 'CÚPLA',
        meaning: 'jdfksdjsl',
        number: 799
    },'2024-04-24': {
        word: 'CÚIRT',
        meaning: 'jdfksdjsl',
        number: 780
    },'2024-04-25': {
        word: 'DORAS',
        meaning: 'jdfksdjsl',
        number: 781
    },'2024-04-26': {
        word: 'OIFIG',
        meaning: 'jdfksdjsl',
        number: 782
    },'2024-04-27': {
        word: 'CÓRAS',
        meaning: 'jdfksdjsl',
        number: 783
    },'2024-04-28': {
        word: 'MÓRÁN',
        meaning: 'jdfksdjsl',
        number: 784
    },'2024-04-29': {
        word: 'SÁSTA',
        meaning: 'jdfksdjsl',
        number: 785
    },'2024-04-30': {
        word: 'INNIU',
        meaning: 'jdfksdjsl',
        number: 786
    },'2024-05-01': {
        word: 'THÍOS',
        meaning: 'jdfksdjsl',
        number: 787
    },'2024-05-02': {
        word: 'FÓILL',
        meaning: 'jdfksdjsl',
        number: 788
    },'2024-05-03': {
        word: 'TURAS',
        meaning: 'jdfksdjsl',
        number: 789
    },'2024-05-04': {
        word: 'LUIGH',
        meaning: 'jdfksdjsl',
        number: 790
    },'2024-05-05': {
        word: 'BEITH',
        meaning: 'jdfksdjsl',
        number: 792
    },'2024-05-06': {
        word: 'RIAIL',
        meaning: 'jdfksdjsl',
        number: 793
    },'2024-05-07': {
        word: 'THUAS',
        meaning: 'jdfksdjsl',
        number: 794
    },'2024-05-08': {
        word: 'BEART',
        meaning: 'jdfksdjsl',
        number: 795
    },'2024-05-09': {
        word: 'LÉAMH',
        meaning: 'jdfksdjsl',
        number: 796
    },'2024-05-10': {
        word: 'DEARA',
        meaning: 'jdfksdjsl',
        number: 797
    },'2024-05-11': {
        word: 'SIOPA',
        meaning: 'jdfksdjsl',
        number: 798
    },'2024-05-12': {
        word: 'LEABA',
        meaning: 'jdfksdjsl',
        number: 799
    },'2024-05-13': {
        word: 'DEICH',
        meaning: 'jdfksdjsl',
        number: 800
    },'2024-05-14': {
        word: 'DEARG',
        meaning: 'jdfksdjsl',
        number: 801
    },'2024-05-15': {
        word: 'EAGLA',
        meaning: 'jdfksdjsl',
        number: 802
    },'2024-05-16': {
        word: 'BAINT',
        meaning: 'jdfksdjsl',
        number: 803
    },'2024-05-17': {
        word: 'GARDA',
        meaning: 'jdfksdjsl',
        number: 804
    },'2024-05-18': {
        word: 'DRÁMA',
        meaning: 'jdfksdjsl',
        number: 805
    },'2024-05-19': {
        word: 'FICHE',
        meaning: 'jdfksdjsl',
        number: 806
    },'2024-05-20': {
        word: 'LUACH',
        meaning: 'jdfksdjsl',
        number: 807
    },'2024-05-21': {
        word: 'RÉIDH',
        meaning: 'jdfksdjsl',
        number: 808
    },'2024-05-22': {
        word: 'NEART',
        meaning: 'jdfksdjsl',
        number: 809
    },'2024-05-23': {
        word: 'TRIÚR',
        meaning: 'jdfksdjsl',
        number: 810
    },'2024-05-24': {
        word: 'AONAR',
        meaning: 'jdfksdjsl',
        number: 811
    },'2024-05-25': {
        word: 'MARBH',
        meaning: 'jdfksdjsl',
        number: 812
    },'2024-05-26': {
        word: 'DEOCH',
        meaning: 'jdfksdjsl',
        number: 813
    },'2024-05-27': {
        word: 'GREIM',
        meaning: 'jdfksdjsl',
        number: 814
    },'2024-05-28': {
        word: 'FOSTA',
        meaning: 'jdfksdjsl',
        number: 815
    },'2024-05-29': {
        word: 'DALTA',
        meaning: 'jdfksdjsl',
        number: 816
    },'2024-05-30': {
        word: 'DROIM',
        meaning: 'jdfksdjsl',
        number: 817
    },'2024-05-31': {
        word: 'FÓGRA',
        meaning: 'jdfksdjsl',
        number: 818      
    },'2024-06-01': {
        word: 'THUAS',
        meaning: 'jdfksdjsl',
        number: 819 }
    ,'2024-06-02': {
         word: 'SPÉIS',
        meaning: 'jdfksdjsl',
        number: 820 }
    ,'2024-06-03': {
        word: 'BEART',
        meaning: 'jdfksdjsl',
        number: 821 }
    ,'2024-06-04': {
        word: 'LÉAMH',
        meaning: 'jdfksdjsl',
        number: 822 }
    ,'2024-06-05': {
        word: 'DEARA',
        meaning: 'jdfksdjsl',
        number: 823 }
    ,'2024-06-06': {
        word: 'SIOPA',
        meaning: 'jdfksdjsl',
        number: 824 }
    ,'2024-06-07': {
        word: 'LEABA',
        meaning: 'jdfksdjsl',
        number: 825 }
    ,'2024-06-08': {
        word: 'DEICH',
        meaning: 'jdfksdjsl',
        number: 826 }
    ,'2024-06-09': {
        word: 'DEARG',
        meaning: 'jdfksdjsl',
        number: 827 }
    ,'2024-06-10': {
        word: 'EAGLA',
        meaning: 'jdfksdjsl',
        number: 828 }
    ,'2024-06-11': {
        word: 'BAINT',
        meaning: 'jdfksdjsl',
        number: 829 }
    ,'2024-06-12': {
        word: 'GARDA',
        meaning: 'jdfksdjsl',
        number: 830 }
    ,'2024-06-13': {
        word: 'DRÁMA',
        meaning: 'jdfksdjsl',
        number: 831 }
    ,'2024-06-14': {
        word: 'FICHE',
        meaning: 'jdfksdjsl',
        number: 832
    },'2024-06-15': {
        word: 'LUACH',
        meaning: 'jdfksdjsl',
        number: 833
    },'2024-06-16': {
        word: 'RÉIDH',
        meaning: 'jdfksdjsl',
        number: 834
    },'2024-06-17': {
        word: 'NEART',
        meaning: 'jdfksdjsl',
        number: 835
    },'2024-06-18': {
        word: 'TRIÚR',
        meaning: 'jdfksdjsl',
        number: 836
    },'2024-06-19': {
        word: 'URLÁR',
        meaning: 'jdfksdjsl',
        number: 837
    },'2024-06-20': {
        word: 'IOMAÍ',
        meaning: 'jdfksdjsl',
        number: 838
    },'2024-06-21': {
        word: 'TEANN',
        meaning: 'jdfksdjsl',
        number: 839
    },'2024-06-22': {
        word: 'CROCH',
        meaning: 'jdfksdjsl',
        number: 840
    },'2024-06-23': {
        word: 'FÓRSA',
        meaning: 'jdfksdjsl',
        number: 841
    },'2024-06-24': {
        word: 'MADRA',
        meaning: 'jdfksdjsl',
        number: 842
    },'2024-06-25': {
        word: 'LAOCH',
        meaning: 'jdfksdjsl',
        number: 843
    },'2024-06-26': {
        word: 'LEASÚ',
        meaning: 'jdfksdjsl',
        number: 844
    },'2024-06-27': {
        word: 'CÓSTA',
        meaning: 'jdfksdjsl',
        number: 845
    },'2024-06-28': {
        word: 'CRUTH',
        meaning: 'jdfksdjsl',
        number: 846
    },'2024-06-29': {
        word: 'ÁTHAS',
        meaning: 'jdfksdjsl',
        number: 847
    },'2024-06-30': {
        word: 'ANONN',
        meaning: 'jdfksdjsl',
        number: 848
    },'2024-07-01': {
        word: 'TÉACS',
        meaning: 'jdfksdjsl',
        number: 849
    },'2024-07-02': {
        word: 'FEIRM',
        meaning: 'jdfksdjsl',
        number: 850
    },'2024-07-03': {
        word: 'HALLA',
        meaning: 'jdfksdjsl',
        number: 851
    },'2024-07-04': {
        word: 'ARAON',
        meaning: 'jdfksdjsl',
        number: 852
    },'2024-07-05': {
        word: 'GLÉAS',
        meaning: 'jdfksdjsl',
        number: 853
    },'2024-07-06': {
        word: 'MISTE',
        meaning: 'jdfksdjsl',
        number: 854
    },'2024-07-07': {
        word: 'BRÉAG',
        meaning: 'jdfksdjsl',
        number: 855
    },'2024-07-08': {
        word: 'GUNNA',
        meaning: 'jdfksdjsl',
        number: 856
    },'2024-07-09': {
        word: 'CAORA',
        meaning: 'jdfksdjsl',
        number: 857
    },'2024-07-10': {
        word: 'ANIAR',
        meaning: 'jdfksdjsl',
        number: 858
    },'2024-07-11': {
        word: 'DEARC',
        meaning: 'jdfksdjsl',
        number: 859
    },'2024-07-12': {
        word: 'MOILL',
        meaning: 'jdfksdjsl',
        number: 860
    },'2024-07-13': {
        word: 'SNÁMH',
        meaning: 'jdfksdjsl',
        number: 861
    },'2024-07-14': {
        word: 'CNÁMH',
        meaning: 'jdfksdjsl',
        number: 862
    },'2024-07-15': {
        word: 'GÉILL',
        meaning: 'jdfksdjsl',
        number: 863
    },'2024-07-16': {
        word: 'CAOIN',
        meaning: 'jdfksdjsl',
        number: 864
    },'2024-07-17': {
        word: 'DRUGA',
        meaning: 'jdfksdjsl',
        number: 865
    },'2024-07-18': {
        word: 'CÁRTA',
        meaning: 'jdfksdjsl',
        number: 866
    },'2024-07-19': {
        word: 'ACHAR',
        meaning: 'jdfksdjsl',
        number: 867
    },'2024-07-20': {
        word: 'CÚIGE',
        meaning: 'jdfksdjsl',
        number: 868
    },'2024-07-21': {
        word: 'IONAS',
        meaning: 'jdfksdjsl',
        number: 869
    },'2024-07-22': {
        word: 'BÁIGH',
        meaning: 'jdfksdjsl',
        number: 870
    },'2024-07-23': {
        word: 'SRUTH',
        meaning: 'jdfksdjsl',
        number: 871
    },'2024-07-24': {
        word: 'FEOIL',
        meaning: 'jdfksdjsl',
        number: 872
    },'2024-07-25': {
        word: 'DÍLIS',
        meaning: 'jdfksdjsl',
        number: 873
    },'2024-07-26': {
        word: 'LOCHT',
        meaning: 'jdfksdjsl',
        number: 874
    },'2024-07-27': {
        word: 'ÉADAN',
        meaning: 'jdfksdjsl',
        number: 875
    },'2024-07-28': {
        word: 'RÚNAÍ',
        meaning: 'jdfksdjsl',
        number: 876
    },'2024-07-29': {
        word: 'STAID',
        meaning: 'jdfksdjsl',
        number: 877
    },'2024-07-30': {
        word: 'ÉASCA',
        meaning: 'jdfksdjsl',
        number: 878
    },'2024-07-31': {
        word: 'SCAIP',
        meaning: 'jdfksdjsl',
        number: 879
    },'2024-08-01': {
        word: 'AISTE',
        meaning: 'jdfksdjsl',
        number: 880
    },'2024-08-02': {
        word: 'SCOTH',
        meaning: 'jdfksdjsl',
        number: 881
    },'2024-08-03': {
        word: 'DRUID',
        meaning: 'jdfksdjsl',
        number: 882
    },'2024-08-04': {
        word: 'CISTE',
        meaning: 'jdfksdjsl',
        number: 883
    },'2024-08-05': {
        word: 'TÉAMA',
        meaning: 'jdfksdjsl',
        number: 884
    },'2024-08-06': {
        word: 'TAIRG',
        meaning: 'jdfksdjsl',
        number: 885
    },'2024-08-07': {
        word: 'OCRAS',
        meaning: 'jdfksdjsl',
        number: 886
    },'2024-08-08': {
        word: 'MAÍGH',
        meaning: 'jdfksdjsl',
        number: 887
    },'2024-08-09': {
        word: 'DEOIR',
        meaning: 'jdfksdjsl',
        number: 888
    },'2024-08-10': {
        word: 'SEINN',
        meaning: 'jdfksdjsl',
        number: 889
    },'2024-08-11': {
        word: 'SONRA',
        meaning: 'jdfksdjsl',
        number: 890
    },'2024-08-12': {
        word: 'TOBAR',
        meaning: 'jdfksdjsl',
        number: 891
    },'2024-08-13': {
        word: 'BÉILE',
        meaning: 'jdfksdjsl',
        number: 892
    },'2024-08-14': {
        word: 'COILL',
        meaning: 'jdfksdjsl',
        number: 893
    },'2024-08-15': {
        word: 'ÓSTÁN',
        meaning: 'jdfksdjsl',
        number: 894
    },'2024-08-16': {
        word: 'MAOIN',
        meaning: 'jdfksdjsl',
        number: 895
    },'2024-08-17': {
        word: 'ACHAN',
        meaning: 'jdfksdjsl',
        number: 896
    },'2024-08-18': {
        word: 'NÁIRE',
        meaning: 'jdfksdjsl',
        number: 897
    },'2024-08-19': {
        word: 'BUNÚS',
        meaning: 'jdfksdjsl',
        number: 898
    },'2024-08-20': {
        word: 'ANALL',
        meaning: 'jdfksdjsl',
        number: 899
    },'2024-08-21': {
        word: 'GNÁCH',
        meaning: 'jdfksdjsl',
        number: 900
    },'2024-08-22': {
        word: 'SCÁTH',
        meaning: 'jdfksdjsl',
        number: 901
    },'2024-08-23': {
        word: 'TRÉIG',
        meaning: 'jdfksdjsl',
        number: 902
    },'2024-08-24': {
        word: 'MÉADÚ',
        meaning: 'jdfksdjsl',
        number: 903
    },'2024-08-25': {
        word: 'CRAOL',
        meaning: 'jdfksdjsl',
        number: 904
    },'2024-08-26': {
        word: 'ÍOMHÁ',
        meaning: 'jdfksdjsl',
        number: 905
    },'2024-08-27': {
        word: 'OTHAR',
        meaning: 'jdfksdjsl',
        number: 906
    },'2024-08-28': {
        word: 'AICME',
        meaning: 'jdfksdjsl',
        number: 907
    },'2024-08-29': {
        word: 'FUAIM',
        meaning: 'jdfksdjsl',
        number: 908
    },'2024-08-30': {
        word: 'GAIRM',
        meaning: 'jdfksdjsl',
        number: 909
    },'2024-08-31': {
        word: 'SÁIGH',
        meaning: 'jdfksdjsl',
        number: 910
    },'2024-09-01': {
        word: 'TIRIM',
        meaning: 'jdfksdjsl',
        number: 911
    },'2024-09-02': {
        word: 'BÁIRE',
        meaning: 'jdfksdjsl',
        number: 912
    },'2024-09-03': {
        word: 'CEIRD',
        meaning: 'jdfksdjsl',
        number: 913
    },'2024-09-04': {
        word: 'GARBH',
        meaning: 'jdfksdjsl',
        number: 914
    },'2024-09-05': {
        word: 'GEATA',
        meaning: 'jdfksdjsl',
        number: 915
    },'2024-09-06': {
        word: 'LIATH',
        meaning: 'jdfksdjsl',
        number: 916
    },'2024-09-07': {
        word: 'MAIDE',
        meaning: 'jdfksdjsl',
        number: 917
    },'2024-09-08': {
        word: 'UAIGH',
        meaning: 'jdfksdjsl',
        number: 918
    },'2024-09-09': {
        word: 'CLUIN',
        meaning: 'jdfksdjsl',
        number: 919
    },'2024-09-10': {
        word: 'DABHT',
        meaning: 'jdfksdjsl',
        number: 920
    },'2024-09-11': {
        word: 'BRAON',
        meaning: 'jdfksdjsl',
        number: 921
    },'2024-09-12': {
        word: 'UAFÁS',
        meaning: 'jdfksdjsl',
        number: 922
    },'2024-09-13': {
        word: 'TÁBLA',
        meaning: 'jdfksdjsl',
        number: 923
    },'2024-09-14': {
        word: 'TRÉAN',
        meaning: 'jdfksdjsl',
        number: 924
    },'2024-09-15': {
        word: 'BANNA',
        meaning: 'jdfksdjsl',
        number: 925
    },'2024-09-16': {
        word: 'CAIRT',
        meaning: 'jdfksdjsl',
        number: 926
    },'2024-09-17': {
        word: 'CLUAS',
        meaning: 'jdfksdjsl',
        number: 927
    },'2024-09-18': {
        word: 'BINSE',
        meaning: 'jdfksdjsl',
        number: 928
    },'2024-09-19': {
        word: 'ANÁIL',
        meaning: 'jdfksdjsl',
        number: 929
    },'2024-09-20': {
        word: 'NEAMH',
        meaning: 'jdfksdjsl',
        number: 930
    },'2024-09-21': {
        word: 'NÁDÚR',
        meaning: 'jdfksdjsl',
        number: 931
    },'2024-09-22': {
        word: 'FÁSTA',
        meaning: 'jdfksdjsl',
        number: 932
    },'2024-09-23': {
        word: 'COSÁN',
        meaning: 'jdfksdjsl',
        number: 933
    },'2024-09-24': {
        word: 'ARDÁN',
        meaning: 'jdfksdjsl',
        number: 934
    },'2024-09-25': {
        word: 'FEADH',
        meaning: 'jdfksdjsl',
        number: 935
    },'2024-09-26': {
        word: 'FEARG',
        meaning: 'jdfksdjsl',
        number: 936
    },'2024-09-27': {
        word: 'CÚLRA',
        meaning: 'jdfksdjsl',
        number: 937
    },'2024-09-28': {
        word: 'AISCE',
        meaning: 'jdfksdjsl',
        number: 938
    },'2024-09-29': {
        word: 'PEANN',
        meaning: 'jdfksdjsl',
        number: 939
    },'2024-09-30': {
        word: 'SRIAN',
        meaning: 'jdfksdjsl',
        number: 940
    },'2024-10-01': {
        word: 'ARÉIR',
        meaning: 'jdfksdjsl',
        number: 941
    },'2024-10-02': {
        word: 'CAITE',
        meaning: 'jdfksdjsl',
        number: 942
    },'2024-10-03': {
        word: 'CLAON',
        meaning: 'jdfksdjsl',
        number: 943
    },'2024-10-04': {
        word: 'GORTA',
        meaning: 'jdfksdjsl',
        number: 944
    },'2024-10-05': {
        word: 'FIACH',
        meaning: 'jdfksdjsl',
        number: 945
    },'2024-10-06': {
        word: 'CASTA',
        meaning: 'jdfksdjsl',
        number: 946
    },'2024-10-07': {
        word: 'DLÚTH',
        meaning: 'jdfksdjsl',
        number: 947
    },'2024-10-08': {
        word: 'CAOGA',
        meaning: 'jdfksdjsl',
        number: 948
    },'2024-10-09': {
        word: 'MÍNIÚ',
        meaning: 'jdfksdjsl',
        number: 949
    },'2024-10-10': {
        word: 'PÉIRE',
        meaning: 'jdfksdjsl',
        number: 950
    },'2024-10-11': {
        word: 'LÁIGH',
        meaning: 'jdfksdjsl',
        number: 951
    },'2024-10-12': {
        word: 'RINCE',
        meaning: 'jdfksdjsl',
        number: 952
    },'2024-10-13': {
        word: 'BARRA',
        meaning: 'jdfksdjsl',
        number: 953
    },'2024-10-14': {
        word: 'CEARC',
        meaning: 'jdfksdjsl',
        number: 954
    },'2024-10-15': {
        word: 'SCUAB',
        meaning: 'jdfksdjsl',
        number: 955
    },'2024-10-16': {
        word: 'PRÁTA',
        meaning: 'jdfksdjsl',
        number: 956
    },'2024-10-17': {
        word: 'NAOMH',
        meaning: 'jdfksdjsl',
        number: 957
    },'2024-10-18': {
        word: 'CLEAS',
        meaning: 'jdfksdjsl',
        number: 958
    },'2024-10-19': {
        word: 'RUAIG',
        meaning: 'jdfksdjsl',
        number: 959
    },'2024-10-20': {
        word: 'GUIGH',
        meaning: 'jdfksdjsl',
        number: 960
    },'2024-10-21': {
        word: 'SCOIR',
        meaning: 'jdfksdjsl',
        number: 961
    },'2024-10-22': {
        word: 'ARMAS',
        meaning: 'jdfksdjsl',
        number: 962
    },'2024-10-23': {
        word: 'FIÁIN',
        meaning: 'jdfksdjsl',
        number: 963
    },'2024-10-24': {
        word: 'PEACA',
        meaning: 'jdfksdjsl',
        number: 964
    },'2024-10-25': {
        word: 'PREAB',
        meaning: 'jdfksdjsl',
        number: 965
    },'2024-10-26': {
        word: 'TAISE',
        meaning: 'jdfksdjsl',
        number: 966
    },'2024-10-27': {
        word: 'SCÁLA',
        meaning: 'jdfksdjsl',
        number: 967
    },'2024-10-28': {
        word: 'GRINN',
        meaning: 'jdfksdjsl',
        number: 968
    },'2024-10-29': {
        word: 'BRÁCH',
        meaning: 'jdfksdjsl',
        number: 969
    },'2024-10-30': {
        word: 'ONÓIR',
        meaning: 'jdfksdjsl',
        number: 970
    },'2024-10-31': {
        word: 'BUILE',
        meaning: 'jdfksdjsl',
        number: 971
    },'2024-11-01': {
        word: 'TITIM',
        meaning: 'jdfksdjsl',
        number: 972
    },'2024-11-02': {
        word: 'AGÓID',
        meaning: 'jdfksdjsl',
        number: 973
    },'2024-11-03': {
        word: 'SACAR',
        meaning: 'jdfksdjsl',
        number: 974
    },'2024-11-04': {
        word: 'COLÚN',
        meaning: 'jdfksdjsl',
        number: 975
    },'2024-11-05': {
        word: 'BRÉAN',
        meaning: 'jdfksdjsl',
        number: 976
    },'2024-11-06': {
        word: 'TEITH',
        meaning: 'jdfksdjsl',
        number: 977
    },'2024-11-07': {
        word: 'EAGAR',
        meaning: 'jdfksdjsl',
        number: 978
    },'2024-11-08': {
        word: 'RÍOGA',
        meaning: 'jdfksdjsl',
        number: 979
    },'2024-11-09': {
        word: 'EOLAÍ',
        meaning: 'jdfksdjsl',
        number: 980
    },'2024-11-10': {
        word: 'PÓSTA',
        meaning: 'jdfksdjsl',
        number: 981
    },'2024-11-11': {
        word: 'ABHUS',
        meaning: 'jdfksdjsl',
        number: 982
    },'2024-11-12': {
        word: 'FUATH',
        meaning: 'jdfksdjsl',
        number: 983
    },'2024-11-13': {
        word: 'RÍOMH',
        meaning: 'jdfksdjsl',
        number: 984
    },'2024-11-14': {
        word: 'DÍOMÁ',
        meaning: 'jdfksdjsl',
        number: 985
    },'2024-11-15': {
        word: 'CUPÁN',
        meaning: 'jdfksdjsl',
        number: 986
    },'2024-11-16': {
        word: 'BUÍON',
        meaning: 'jdfksdjsl',
        number: 987
    },'2024-11-17': {
        word: 'GLEIC',
        meaning: 'jdfksdjsl',
        number: 988
    },'2024-11-18': {
        word: 'ÉACHT',
        meaning: 'jdfksdjsl',
        number: 989
    },'2024-11-19': {
        word: 'DLIGH',
        meaning: 'jdfksdjsl',
        number: 990
    },'2024-11-20': {
        word: 'SCIAN',
        meaning: 'jdfksdjsl',
        number: 991
    },'2024-11-21': {
        word: 'FÁISC',
        meaning: 'jdfksdjsl',
        number: 992
    },'2024-11-22': {
        word: 'PLÁTA',
        meaning: 'jdfksdjsl',
        number: 993
    },'2024-11-23': {
        word: 'ITHIR',
        meaning: 'jdfksdjsl',
        number: 994
    },'2024-11-24': {
        word: 'IOMAD',
        meaning: 'jdfksdjsl',
        number: 995
    },'2024-11-25': {
        word: 'DÍBIR',
        meaning: 'jdfksdjsl',
        number: 996
    },'2024-11-26': {
        word: 'SCÁIL',
        meaning: 'jdfksdjsl',
        number: 997
    },'2024-11-27': {
        word: 'EITIL',
        meaning: 'jdfksdjsl',
        number: 998
    },'2024-11-28': {
        word: 'FEITH',
        meaning: 'jdfksdjsl',
        number: 999
    },'2024-11-29': {
        word: 'TOBAC',
        meaning: 'jdfksdjsl',
        number: 1000
    },'2024-11-30': {
        word: 'FIONN',
        meaning: 'jdfksdjsl',
        number: 1001
    },'2024-11-31': {
        word: 'CRITH',
        meaning: 'jdfksdjsl',
        number: 1002
    },'2024-12-01': {
        word: 'TEIST',
        meaning: 'jdfksdjsl',
        number: 1003
    },'2024-12-02': {
        word: 'BRÁID',
        meaning: 'jdfksdjsl',
        number: 1004
    },'2024-12-03': {
        word: 'LÉINE',
        meaning: 'jdfksdjsl',
        number: 1005
    },'2024-12-04': {
        word: 'SCATA',
        meaning: 'jdfksdjsl',
        number: 1006
    },'2024-12-05': {
        word: 'GIOTA',
        meaning: 'jdfksdjsl',
        number: 1007
    },'2024-12-06': {
        word: 'FEALL',
        meaning: 'jdfksdjsl',
        number: 1008
    },'2024-12-07': {
        word: 'SCAIR',
        meaning: 'jdfksdjsl',
        number: 1009
    },'2024-12-08': {
        word: 'TOIRT',
        meaning: 'jdfksdjsl',
        number: 1010
    },'2024-12-09': {
        word: 'SCIOB',
        meaning: 'jdfksdjsl',
        number: 1011
    },'2024-12-10': {
        word: 'DAITE',
        meaning: 'jdfksdjsl',
        number: 1012
    },'2024-12-11': {
        word: 'RÉIGH',
        meaning: 'jdfksdjsl',
        number: 1013
    },'2024-12-12': {
        word: 'COGAR',
        meaning: 'jdfksdjsl',
        number: 1014
    },'2024-12-13': {
        word: 'TANAÍ',
        meaning: 'jdfksdjsl',
        number: 1015
    },'2024-12-14': {
        word: 'OIBRÍ',
        meaning: 'jdfksdjsl',
        number: 1016
    },'2024-12-15': {
        word: 'SUITE',
        meaning: 'jdfksdjsl',
        number: 1017
    },'2024-12-16': {
        word: 'MUISE',
        meaning: 'jdfksdjsl',
        number: 1018
    },'2024-12-17': {
        word: 'CAMPA',
        meaning: 'jdfksdjsl',
        number: 1019
    },'2024-12-18': {
        word: 'RÚNDA',
        meaning: 'jdfksdjsl',
        number: 1020
    },'2024-12-19': {
        word: 'TOGHA',
        meaning: 'jdfksdjsl',
        number: 1021
    },'2024-12-20': {
        word: 'DÚNTA',
        meaning: 'jdfksdjsl',
        number: 1022
    },'2024-12-21': {
        word: 'CLÉIR',
        meaning: 'jdfksdjsl',
        number: 1023
    },'2024-12-22': {
        word: 'GNÉAS',
        meaning: 'jdfksdjsl',
        number: 1024
    },'2024-12-23': {
        word: 'GASTA',
        meaning: 'jdfksdjsl',
        number: 1025
    },'2024-12-24': {
        word: 'TÁIRG',
        meaning: 'jdfksdjsl',
        number: 1026
    },'2024-12-25': {
        word: 'ALLAS',
        meaning: 'jdfksdjsl',
        number: 1027
    },'2024-12-26': {
        word: 'SÁILE',
        meaning: 'jdfksdjsl',
        number: 1028
    },'2024-12-27': {
        word: 'DOIRT',
        meaning: 'jdfksdjsl',
        number: 1029
    },'2024-12-28': {
        word: 'DÚLRA',
        meaning: 'jdfksdjsl',
        number: 1030
    },'2024-12-29': {
        word: 'TIUBH',
        meaning: 'jdfksdjsl',
        number: 1031
    },'2024-12-30': {
        word: 'FINNÉ',
        meaning: 'jdfksdjsl',
        number: 1032
    },'2024-12-31': {
        word: 'BOTÚN',
        meaning: 'jdfksdjsl',
        number: 1033
    },'2025-01-01': {
        word: 'ALBAM',
        meaning: 'jdfksdjsl',
        number: 1034
    },'2025-01-02': {
        word: 'PÍOPA',
        meaning: 'jdfksdjsl',
        number: 1035
    },'2025-01-03': {
        word: 'TOGRA',
        meaning: 'jdfksdjsl',
        number: 1036
    },'2025-01-04': {
        word: 'ÓRÁID',
        meaning: 'jdfksdjsl',
        number: 1037
    },'2025-01-05': {
        word: 'BLAIS',
        meaning: 'jdfksdjsl',
        number: 1038
    },'2025-01-06': {
        word: 'SEACH',
        meaning: 'jdfksdjsl',
        number: 1039
    },'2025-01-07': {
        word: 'NEACH',
        meaning: 'jdfksdjsl',
        number: 1040
    },'2025-01-08': {
        word: 'FAILL',
        meaning: 'jdfksdjsl',
        number: 1041
    },'2025-01-09': {
        word: 'MILIS',
        meaning: 'jdfksdjsl',
        number: 1042
    },'2025-01-10': {
        word: 'TARBH',
        meaning: 'jdfksdjsl',
        number: 1043
    },'2025-01-11': {
        word: 'MÚNLA',
        meaning: 'jdfksdjsl',
        number: 1044
    },'2025-01-12': {
        word: 'MÉARA',
        meaning: 'jdfksdjsl',
        number: 1045
    },'2025-01-13': {
        word: 'FÍRIC',
        meaning: 'jdfksdjsl',
        number: 1046
    },'2025-01-14': {
        word: 'BUAMA',
        meaning: 'jdfksdjsl',
        number: 1047
    },'2025-01-15': {
        word: 'BAIST',
        meaning: 'jdfksdjsl',
        number: 1048
    },'2025-01-16': {
        word: 'CRIOS',
        meaning: 'jdfksdjsl',
        number: 1049
    },'2025-01-17': {
        word: 'LEAID',
        meaning: 'jdfksdjsl',
        number: 1050
    },'2025-01-18': {
        word: 'MEATH',
        meaning: 'jdfksdjsl',
        number: 1051
    },'2025-01-19': {
        word: 'AOSTA',
        meaning: 'jdfksdjsl',
        number: 1052
    },'2025-01-20': {
        word: 'SEILG',
        meaning: 'jdfksdjsl',
        number: 1053
    },'2025-01-21': {
        word: 'GOILL',
        meaning: 'jdfksdjsl',
        number: 1054
    },'2025-01-22': {
        word: 'SÉIMH',
        meaning: 'jdfksdjsl',
        number: 1040
    },'2025-01-23': {
        word: 'SCÍTH',
        meaning: 'jdfksdjsl',
        number: 1041
    },'2025-01-24': {
        word: 'PUINN',
        meaning: 'jdfksdjsl',
        number: 1042
    },'2025-01-25': {
        word: 'RIALÚ',
        meaning: 'jdfksdjsl',
        number: 1043
    },'2025-01-26': {
        word: 'GADAÍ',
        meaning: 'jdfksdjsl',
        number: 1044
    },'2025-01-27': {
        word: 'MAISE',
        meaning: 'jdfksdjsl',
        number: 1045
    },'2025-01-28': {
        word: 'IMIRT',
        meaning: 'jdfksdjsl',
        number: 1046
    },'2025-01-29': {
        word: 'OCHTÓ',
        meaning: 'jdfksdjsl',
        number: 1047
    },'2025-01-30': {
        word: 'CRAIC',
        meaning: 'jdfksdjsl',
        number: 1048
    },'2025-01-31': {
        word: 'OLANN',
        meaning: 'jdfksdjsl',
        number: 1049
    },'2025-02-01': {
        word: 'SÚIGH',
        meaning: 'jdfksdjsl',
        number: 1050
    },'2025-02-02': {
        word: 'DOCHT',
        meaning: 'jdfksdjsl',
        number: 1051
    },'2025-02-03': {
        word: 'AILSE',
        meaning: 'jdfksdjsl',
        number: 1052
    },'2025-02-04': {
        word: 'CANNA',
        meaning: 'jdfksdjsl',
        number: 1053
    },'2025-02-05': {
        word: 'FAIRE',
        meaning: 'jdfksdjsl',
        number: 1054
    },'2025-02-06': {
        word: 'CAOCH',
        meaning: 'jdfksdjsl',
        number: 1055
    },'2025-02-07': {
        word: 'SÍODA',
        meaning: 'jdfksdjsl',
        number: 1056
    },'2025-02-08': {
        word: 'EADAR',
        meaning: 'jdfksdjsl',
        number: 1057
    },'2025-02-09': {
        word: 'CUMHA',
        meaning: 'jdfksdjsl',
        number: 1058
    },'2025-02-10': {
        word: 'CAIFE',
        meaning: 'jdfksdjsl',
        number: 1059
    },'2025-02-11': {
        word: 'SÓLÁS',
        meaning: 'jdfksdjsl',
        number: 1060
    },'2025-02-12': {
        word: 'SÁITH',
        meaning: 'jdfksdjsl',
        number: 1061
    },'2025-02-13': {
        word: 'RÁFLA',
        meaning: 'jdfksdjsl',
        number: 1061
    },'2025-02-14': {
        word: 'CUACH',
        meaning: 'jdfksdjsl',
        number: 1062
    },'2025-02-15': {
        word: 'AIRNE',
        meaning: 'jdfksdjsl',
        number: 1063
    },'2025-02-16': {
        word: 'ALCÓL',
        meaning: 'jdfksdjsl',
        number: 1064
    },'2025-02-17': {
        word: 'LUIBH',
        meaning: 'jdfksdjsl',
        number: 1065
    },'2025-02-18': {
        word: 'TNÚTH',
        meaning: 'jdfksdjsl',
        number: 1066
    },'2025-02-19': {
        word: 'CEARR',
        meaning: 'jdfksdjsl',
        number: 1067
    },'2025-02-20': {
        word: 'TACHT',
        meaning: 'jdfksdjsl',
        number: 1068
    },'2025-02-21': {
        word: 'TUILE',
        meaning: 'jdfksdjsl',
        number: 1069
    },'2025-02-22': {
        word: 'BEACH',
        meaning: 'jdfksdjsl',
        number: 1070
    },'2025-02-23': {
        word: 'ÉINDÍ',
        meaning: 'jdfksdjsl',
        number: 1071
    },'2025-02-24': {
        word: 'ANOIR',
        meaning: 'jdfksdjsl',
        number: 1072
    },'2025-02-25': {
        word: 'SCIAR',
        meaning: 'jdfksdjsl',
        number: 1073
    },'2025-02-26': {
        word: 'PLÁNA',
        meaning: 'jdfksdjsl',
        number: 1074
    },'2025-02-27': {
        word: 'BEOLA',
        meaning: 'jdfksdjsl',
        number: 1075
    },'2025-02-28': {
        word: 'CREAT',
        meaning: 'jdfksdjsl',
        number: 1076
    },'2025-02-29': {
        word: 'CRÓGA',
        meaning: 'jdfksdjsl',
        number: 1077
    },'2025-03-01': {
        word: 'MOTHÚ',
        meaning: 'jdfksdjsl',
        number: 1078
    },'2025-03-02': {
        word: 'THUSA',
        meaning: 'jdfksdjsl',
        number: 1079
    },'2025-03-03': {
        word: 'AOIBH',
        meaning: 'jdfksdjsl',
        number: 1080
    },'2025-03-04': {
        word: 'SICÍN',
        meaning: 'jdfksdjsl',
        number: 1081
    },'2025-03-05': {
        word: 'BEARR',
        meaning: 'jdfksdjsl',
        number: 1082
    },'2025-03-06': {
        word: 'FÉITH',
        meaning: 'jdfksdjsl',
        number: 1083
    },'2025-03-07': {
        word: 'ORTHA',
        meaning: 'jdfksdjsl',
        number: 1084
    },'2025-03-08': {
        word: 'FORÁS',
        meaning: 'jdfksdjsl',
        number: 1085
    },'2025-03-09': {
        word: 'MASLA',
        meaning: 'jdfksdjsl',
        number: 1086
    },'2025-03-10': {
        word: 'CÓNRA',
        meaning: 'jdfksdjsl',
        number: 1087
    },'2025-03-11': {
        word: 'TRIAN',
        meaning: 'jdfksdjsl',
        number: 1088
    },'2025-03-12': {
        word: 'DHEIN',
        meaning: 'jdfksdjsl',
        number: 1089
    },'2025-03-13': {
        word: 'CEILT',
        meaning: 'jdfksdjsl',
        number: 1090
    },'2025-03-14': {
        word: 'TOSAÍ',
        meaning: 'jdfksdjsl',
        number: 1091
    },'2025-03-15': {
        word: 'STAON',
        meaning: 'jdfksdjsl',
        number: 1092
    },'2025-03-16': {
        word: 'GOILE',
        meaning: 'jdfksdjsl',
        number: 1093
    },'2025-03-17': {
        word: 'TUAMA',
        meaning: 'jdfksdjsl',
        number: 1094
    },'2025-03-18': {
        word: 'UACHT',
        meaning: 'jdfksdjsl',
        number: 1095
    },'2025-03-19': {
        word: 'PEATA',
        meaning: 'jdfksdjsl',
        number: 1096
    },'2025-03-20': {
        word: 'LAIGE',
        meaning: 'jdfksdjsl',
        number: 1097
    },'2025-03-21': {
        word: 'STOCA',
        meaning: 'jdfksdjsl',
        number: 1098
    },'2025-03-22': {
        word: 'FRÁMA',
        meaning: 'jdfksdjsl',
        number: 1099
    },'2025-03-23': {
        word: 'SCAIF',
        meaning: 'jdfksdjsl',
        number: 2000
    },'2025-03-24': {
        word: 'DRAOI',
        meaning: 'jdfksdjsl',
        number: 2001
    },'2025-03-25': {
        word: 'BEANN',
        meaning: 'jdfksdjsl',
        number: 2002
    },'2025-03-26': {
        word: 'GLÓIR',
        meaning: 'jdfksdjsl',
        number: 2003
    },'2025-03-27': {
        word: 'TEILG',
        meaning: 'jdfksdjsl',
        number: 2004
    },'2025-03-28': {
        word: 'PÉIST',
        meaning: 'jdfksdjsl',
        number: 2005
    },'2025-03-29': {
        word: 'LUASC',
        meaning: 'jdfksdjsl',
        number: 2006
    },'2025-03-30': {
        word: 'CATHÚ',
        meaning: 'jdfksdjsl',
        number: 2007
    },'2025-03-31': {
        word: 'SÉALA',
        meaning: 'jdfksdjsl',
        number: 2008
    },'2025-04-01': {
        word: 'RACHT',
        meaning: 'jdfksdjsl',
        number: 2009
    },'2025-04-02': {
        word: 'ÍDIGH',
        meaning: 'jdfksdjsl',
        number: 2010
    },'2025-04-03': {
        word: 'SNÁTH',
        meaning: 'jdfksdjsl',
        number: 2011
    },'2025-04-04': {
        word: 'UAIMH',
        meaning: 'jdfksdjsl',
        number: 2012
    },'2025-04-05': {
        word: 'CASÓG',
        meaning: 'jdfksdjsl',
        number: 2013
    },'2025-04-06': {
        word: 'OILTE',
        meaning: 'jdfksdjsl',
        number: 2014
    },'2025-04-07': {
        word: 'SMIOR',
        meaning: 'jdfksdjsl',
        number: 2015
    },'2025-04-08': {
        word: 'CÚISÍ',
        meaning: 'jdfksdjsl',
        number: 2016
    },'2025-04-09': {
        word: 'CÍSTE',
        meaning: 'jdfksdjsl',
        number: 2017
    },'2025-04-10': {
        word: 'IREAS',
        meaning: 'jdfksdjsl',
        number: 2018
    },'2025-04-11': {
        word: 'TARLÚ',
        meaning: 'jdfksdjsl',
        number: 2019
    },'2025-04-12': {
        word: 'BALBH',
        meaning: 'jdfksdjsl',
        number: 2020
    },'2025-04-13': {
        word: 'COTHÚ',
        meaning: 'jdfksdjsl',
        number: 2021
    },'2025-04-14': {
        word: 'PÚDAR',
        meaning: 'jdfksdjsl',
        number: 2022
    },'2025-04-15': {
        word: 'SONAS',
        meaning: 'jdfksdjsl',
        number: 2023
    },'2025-04-16': {
        word: 'SEIFT',
        meaning: 'jdfksdjsl',
        number: 2024
    },'2025-04-17': {
        word: 'BEOIR',
        meaning: 'jdfksdjsl',
        number: 2025
    },'2025-04-18': {
        word: 'LAMPA',
        meaning: 'jdfksdjsl',
        number: 2026
    },'2025-04-19': {
        word: 'MEAIG',
        meaning: 'jdfksdjsl',
        number: 2027
    },'2025-04-20': {
        word: 'CAIFÉ',
        meaning: 'jdfksdjsl',
        number: 2028
    },'2025-04-21': {
        word: 'ÉIRIM',
        meaning: 'jdfksdjsl',
        number: 2029
    },'2025-04-22': {
        word: 'STRAE',
        meaning: 'jdfksdjsl',
        number: 2030
    },'2025-04-23': {
        word: 'MAMAÍ',
        meaning: 'jdfksdjsl',
        number: 2031
    },'2025-04-24': {
        word: 'UMHAL',
        meaning: 'jdfksdjsl',
        number: 2032
    },'2025-04-25': {
        word: 'MIONN',
        meaning: 'jdfksdjsl',
        number: 2033
    },'2025-04-26': {
        word: 'CÍOCH',
        meaning: 'jdfksdjsl',
        number: 2034
    },'2025-04-27': {
        word: 'COISC',
        meaning: 'jdfksdjsl',
        number: 2035
    },'2025-04-28': {
        word: 'TUATA',
        meaning: 'jdfksdjsl',
        number: 2036
    },'2025-04-29': {
        word: 'TÉAMH',
        meaning: 'jdfksdjsl',
        number: 2037
    },'2025-04-30': {
        word: 'INMHE',
        meaning: 'jdfksdjsl',
        number: 2038
    },'2025-05-01': {
        word: 'DREAP',
        meaning: 'jdfksdjsl',
        number: 2039
    },'2025-05-02': {
        word: 'BHEIR',
        meaning: 'jdfksdjsl',
        number: 2040
    },'2025-05-03': {
        word: 'UATHA',
        meaning: 'jdfksdjsl',
        number: 2041
    },'2025-05-04': {
        word: 'SEILF',
        meaning: 'jdfksdjsl',
        number: 2042
    },'2025-05-05': {
        word: 'LEOGA',
        meaning: 'jdfksdjsl',
        number: 2043
    },'2025-05-06': {
        word: 'NÓCHA',
        meaning: 'jdfksdjsl',
        number: 2044
    },'2025-05-07': {
        word: 'GONTA',
        meaning: 'jdfksdjsl',
        number: 2045
    },'2025-05-08': {
        word: 'IOMRÁ',
        meaning: 'jdfksdjsl',
        number: 2046
    },'2025-05-09': {
        word: 'DREAS',
        meaning: 'jdfksdjsl',
        number: 2047
    },'2025-05-10': {
        word: 'DÉIRC',
        meaning: 'jdfksdjsl',
        number: 2048
    },'2025-05-11': {
        word: 'ADAMH',
        meaning: 'jdfksdjsl',
        number: 2049
    },'2025-05-12': {
        word: 'DÍOBH',
        meaning: 'jdfksdjsl',
        number: 2050
    },'2025-05-13': {
        word: 'GREAD',
        meaning: 'jdfksdjsl',
        number: 2051
    },'2025-05-14': {
        word: 'LEANN',
        meaning: 'jdfksdjsl',
        number: 2052
    },'2025-05-15': {
        word: 'OLCAS',
        meaning: 'jdfksdjsl',
        number: 2053
    },'2025-05-16': {
        word: 'URNAÍ',
        meaning: 'jdfksdjsl',
        number: 2054
    },'2025-05-17': {
        word: 'GORTÚ',
        meaning: 'jdfksdjsl',
        number: 2055
    },'2025-05-18': {
        word: 'CEARN',
        meaning: 'jdfksdjsl',
        number: 2056
    },'2025-05-19': {
        word: 'IOLRA',
        meaning: 'jdfksdjsl',
        number: 2056
    },'2025-05-20': {
        word: 'GNÚIS',
        meaning: 'jdfksdjsl',
        number: 2057
    },'2025-05-21': {
        word: 'PÉINT',
        meaning: 'jdfksdjsl',
        number: 2058
    },'2025-05-22': {
        word: 'STAIC',
        meaning: 'jdfksdjsl',
        number: 2059
    },'2025-05-23': {
        word: 'BUAIR',
        meaning: 'jdfksdjsl',
        number: 2060
    },'2025-05-24': {
        word: 'TOCHT',
        meaning: 'jdfksdjsl',
        number: 2061
    },'2025-05-25': {
        word: 'FOSTÚ',
        meaning: 'jdfksdjsl',
        number: 2062
    },'2025-05-26': {
        word: 'URRÚS',
        meaning: 'jdfksdjsl',
        number: 2063
    },'2025-05-27': {
        word: 'LEAMH',
        meaning: 'jdfksdjsl',
        number: 2064
    },'2025-05-28': {
        word: 'DÓITE',
        meaning: 'jdfksdjsl',
        number: 2065
    },'2025-05-29': {
        word: 'TOISE',
        meaning: 'jdfksdjsl',
        number: 2066
    },'2025-05-30': {
        word: 'DAIDÍ',
        meaning: 'jdfksdjsl',
        number: 2067
    },'2025-05-31': {
        word: 'GEALT',
        meaning: 'jdfksdjsl',
        number: 2068
    },'2025-06-01': {
        word: 'TONNA',
        meaning: 'jdfksdjsl',
        number: 2068
    },'2025-06-02': {
        word: 'FOCLA',
        meaning: 'jdfksdjsl',
        number: 2069
    },'2025-06-03': {
        word: 'SAINT',
        meaning: 'jdfksdjsl',
        number: 2070
    },'2025-06-04': {
        word: 'GREAN',
        meaning: 'jdfksdjsl',
        number: 2071
    },'2025-06-05': {
        word: 'AOIRE',
        meaning: 'jdfksdjsl',
        number: 2072
    },'2025-06-06': {
        word: 'NÉATA',
        meaning: 'jdfksdjsl',
        number: 2073
    },'2025-06-07': {
        word: 'ORDÓG',
        meaning: 'jdfksdjsl',
        number: 2074
    },'2025-06-08': {
        word: 'LIOPA',
        meaning: 'jdfksdjsl',
        number: 2075
    },'2025-06-09': {
        word: 'FINNE',
        meaning: 'jdfksdjsl',
        number: 2076
    },'2025-06-10': {
        word: 'ÚRNUA',
        meaning: 'jdfksdjsl',
        number: 2077
    },'2025-06-11': {
        word: 'TRÉAD',
        meaning: 'jdfksdjsl',
        number: 2078
    },'2025-06-12': {
        word: 'CÉIMÍ',
        meaning: 'jdfksdjsl',
        number: 2079
    },'2025-06-13': {
        word: 'CREIM',
        meaning: 'jdfksdjsl',
        number: 2080
    },'2025-06-14': {
        word: 'SPOTA',
        meaning: 'jdfksdjsl',
        number: 2081
    },'2025-06-15': {
        word: 'DONAS',
        meaning: 'jdfksdjsl',
        number: 2082
    },'2025-06-16': {
        word: 'COIRM',
        meaning: 'jdfksdjsl',
        number: 2083
    },'2025-06-17': {
        word: 'CAMÁN',
        meaning: 'jdfksdjsl',
        number: 2084
    },'2025-06-18': {
        word: 'LEOMH',
        meaning: 'jdfksdjsl',
        number: 2085
    },'2025-06-19': {
        word: 'CHÓIR',
        meaning: 'jdfksdjsl',
        number: 2086
    },'2025-06-20': {
        word: 'IDÉAL',
        meaning: 'jdfksdjsl',
        number: 2087
    },'2025-06-21': {
        word: 'DÍNIT',
        meaning: 'jdfksdjsl',
        number: 2088
    },'2025-06-22': {
        word: 'CIPÍN',
        meaning: 'jdfksdjsl',
        number: 2089
    },'2025-06-23': {
        word: 'SAILL',
        meaning: 'jdfksdjsl',
        number: 2090
    },'2025-06-24': {
        word: 'FÓCAS',
        meaning: 'jdfksdjsl',
        number: 2091
    },'2025-06-25': {
        word: 'CÓFRA',
        meaning: 'jdfksdjsl',
        number: 2092
    },'2025-06-26': {
        word: 'ASPAL',
        meaning: 'jdfksdjsl',
        number: 2093
    },'2025-06-27': {
        word: 'PÁLÁS',
        meaning: 'jdfksdjsl',
        number: 2094
    },'2025-06-28': {
        word: 'CLAIS',
        meaning: 'jdfksdjsl',
        number: 2095
    },'2025-06-29': {
        word: 'SLIOS',
        meaning: 'jdfksdjsl',
        number: 2096
    },'2025-06-30': {
        word: 'FÓNTA',
        meaning: 'jdfksdjsl',
        number: 2097
    },'2025-07-01': {
        word: 'COPAR',
        meaning: 'jdfksdjsl',
        number: 2098
    },'2025-07-02': {
        word: 'AICÍD',
        meaning: 'jdfksdjsl',
        number: 2099
    },'2025-07-03': {
        word: 'SPÍON',
        meaning: 'jdfksdjsl',
        number: 3000
    },'2025-07-04': {
        word: 'STUIF',
        meaning: 'jdfksdjsl',
        number: 3001
    },'2025-07-05': {
        word: 'GIALL',
        meaning: 'jdfksdjsl',
        number: 3002
    },'2025-07-06': {
        word: 'COIRE',
        meaning: 'jdfksdjsl',
        number: 3003
    },'2025-07-07': {
        word: 'DIAGA',
        meaning: 'jdfksdjsl',
        number: 3004
    },'2025-07-08': {
        word: 'GRÁIN',
        meaning: 'jdfksdjsl',
        number: 3005
    },'2025-07-09': {
        word: 'BÁÚIL',
        meaning: 'jdfksdjsl',
        number: 3006
    },'2025-07-10': {
        word: 'SODAR',
        meaning: 'jdfksdjsl',
        number: 3007
    },'2025-07-11': {
        word: 'MODÚL',
        meaning: 'jdfksdjsl',
        number: 3008
    },'2025-07-12': {
        word: 'DEASC',
        meaning: 'jdfksdjsl',
        number: 3009
    },'2025-07-13': {
        word: 'DEOIN',
        meaning: 'jdfksdjsl',
        number: 3010
    },'2025-07-14': {
        word: 'UAINE',
        meaning: 'jdfksdjsl',
        number: 3011
    },'2025-07-15': {
        word: 'BUAIC',
        meaning: 'jdfksdjsl',
        number: 3012
    },'2025-07-16': {
        word: 'STRUS',
        meaning: 'jdfksdjsl',
        number: 3013
    },'2025-07-17': {
        word: 'ÉIGSE',
        meaning: 'jdfksdjsl',
        number: 3014
    },'2025-07-18': {
        word: 'PUTÓG',
        meaning: 'jdfksdjsl',
        number: 3015
    },'2025-07-19': {
        word: 'LOISC',
        meaning: 'jdfksdjsl',
        number: 3016
    },'2025-07-20': {
        word: 'LÍOMH',
        meaning: 'jdfksdjsl',
        number: 3017
    },'2025-07-21': {
        word: 'ANEAS',
        meaning: 'jdfksdjsl',
        number: 3018
    },'2025-07-22': {
        word: 'CLÁRÚ',
        meaning: 'jdfksdjsl',
        number: 3019
    },'2025-07-23': {
        word: 'SEOID',
        meaning: 'jdfksdjsl',
        number: 3020
    },'2025-07-24': {
        word: 'DAOFA',
        meaning: 'jdfksdjsl',
        number: 3021
    },'2025-07-25': {
        word: 'FÁSRA',
        meaning: 'jdfksdjsl',
        number: 3022
    },'2025-07-26': {
        word: 'DRUMA',
        meaning: 'jdfksdjsl',
        number: 3023
    },'2025-07-27': {
        word: 'IONGA',
        meaning: 'jdfksdjsl',
        number: 3024
    },'2025-07-28': {
        word: 'BOGHA',
        meaning: 'jdfksdjsl',
        number: 3025
    },'2025-07-29': {
        word: 'TRÁTA',
        meaning: 'jdfksdjsl',
        number: 3026
    },'2025-07-30': {
        word: 'BACÁN',
        meaning: 'jdfksdjsl',
        number: 3027
    },'2025-07-31': {
        word: 'TACAR',
        meaning: 'jdfksdjsl',
        number: 3028
    },'2025-08-01': {
        word: 'CASÚR',
        meaning: 'jdfksdjsl',
        number: 3029
    },'2025-08-02': {
        word: 'ROLLA',
        meaning: 'jdfksdjsl',
        number: 3030
    },'2025-08-03': {
        word: 'CLÚMH',
        meaning: 'jdfksdjsl',
        number: 3031
    },'2025-08-04': {
        word: 'LEASC',
        meaning: 'jdfksdjsl',
        number: 3032
    },'2025-08-05': {
        word: 'LÍOFA',
        meaning: 'jdfksdjsl',
        number: 3034
    },'2025-08-06': {
        word: 'GRÉAS',
        meaning: 'jdfksdjsl',
        number: 3035
    },'2025-08-07': {
        word: 'SLÁNÚ',
        meaning: 'jdfksdjsl',
        number: 3036
    },'2025-08-08': {
        word: 'PLÚCH',
        meaning: 'jdfksdjsl',
        number: 3037
    },'2025-08-09': {
        word: 'CUING',
        meaning: 'jdfksdjsl',
        number: 3038
    },'2025-08-10': {
        word: 'ALLTA',
        meaning: 'jdfksdjsl',
        number: 3039
    },'2025-08-11': {
        word: 'CORCA',
        meaning: 'jdfksdjsl',
        number: 3041
    },'2025-08-12': {
        word: 'IOLAR',
        meaning: 'jdfksdjsl',
        number: 3042
    },'2025-08-13': {
        word: 'ARANN',
        meaning: 'jdfksdjsl',
        number: 3043
    },'2025-08-14': {
        word: 'SFÉAR',
        meaning: 'jdfksdjsl',
        number: 3044
    },'2025-08-15': {
        word: 'FUAID',
        meaning: 'jdfksdjsl',
        number: 3045
    },'2025-08-16': {
        word: 'DRÉIM',
        meaning: 'jdfksdjsl',
        number: 3046
    },'2025-08-17': {
        word: 'TEIBÍ',
        meaning: 'jdfksdjsl',
        number: 3047
    },'2025-08-18': {
        word: 'GÁTAR',
        meaning: 'jdfksdjsl',
        number: 3048
    },'2025-08-19': {
        word: 'PRIOC',
        meaning: 'jdfksdjsl',
        number: 3049
    },'2025-08-20': {
        word: 'SPRID',
        meaning: 'jdfksdjsl',
        number: 3050
    },'2025-08-21': {
        word: 'SMÉAR',
        meaning: 'jdfksdjsl',
        number: 3051
    },'2025-08-22': {
        word: 'GOTHA',
        meaning: 'jdfksdjsl',
        number: 3052
    },'2025-08-23': {
        word: 'PLUID',
        meaning: 'jdfksdjsl',
        number: 3053
    },'2025-08-24': {
        word: 'COLÚR',
        meaning: 'jdfksdjsl',
        number: 3054
    },'2025-08-25': {
        word: 'DÁIMH',
        meaning: 'jdfksdjsl',
        number: 3055
    },'2025-08-26': {
        word: 'SÍNIÚ',
        meaning: 'jdfksdjsl',
        number: 3056
    },'2025-08-27': {
        word: 'LIONN',
        meaning: 'jdfksdjsl',
        number: 3057
    },'2025-08-28': {
        word: 'FÁIDH',
        meaning: 'jdfksdjsl',
        number: 3058
    },'2025-08-29': {
        word: 'ATHRÁ',
        meaning: 'jdfksdjsl',
        number: 3059
    },'2025-08-30': {
        word: 'FRÁSA',
        meaning: 'jdfksdjsl',
        number: 3060
    },'2025-08-31': {
        word: 'GOIRT',
        meaning: 'jdfksdjsl',
        number: 3061
    },'2025-09-01': {
        word: 'MÉITH',
        meaning: 'jdfksdjsl',
        number: 3062
    },'2025-09-02': {
        word: 'ORGÁN',
        meaning: 'jdfksdjsl',
        number: 3063
    },'2025-09-03': {
        word: 'SOLAD',
        meaning: 'jdfksdjsl',
        number: 3064
    },'2025-09-04': {
        word: 'MATÁN',
        meaning: 'jdfksdjsl',
        number: 3065
    },'2025-09-05': {
        word: 'SMÉID',
        meaning: 'jdfksdjsl',
        number: 3066
    },'2025-09-06': {
        word: 'GABHA',
        meaning: 'jdfksdjsl',
        number: 3067
    },'2025-09-07': {
        word: 'BÁBÓG',
        meaning: 'jdfksdjsl',
        number: 3068
    },'2025-09-08': {
        word: 'CÁBÁN',
        meaning: 'jdfksdjsl',
        number: 3069
    },'2025-09-09': {
        word: 'TAISC',
        meaning: 'jdfksdjsl',
        number: 3070
    },'2025-09-10': {
        word: 'TARNA',
        meaning: 'jdfksdjsl',
        number: 3071
    },'2025-09-11': {
        word: 'AGAIR',
        meaning: 'jdfksdjsl',
        number: 3072
    },'2025-09-12': {
        word: 'FIUCH',
        meaning: 'jdfksdjsl',
        number: 3073
    },'2025-09-13': {
        word: 'FOLÚS',
        meaning: 'jdfksdjsl',
        number: 3074
    },'2025-09-14': {
        word: 'RIBÍN',
        meaning: 'jdfksdjsl',
        number: 3075
    },'2025-09-15': {
        word: 'SÚGÁN',
        meaning: 'jdfksdjsl',
        number: 3076
    },'2025-09-16': {
        word: 'BANBH',
        meaning: 'jdfksdjsl',
        number: 3077
    },'2025-09-17': {
        word: 'STAIL',
        meaning: 'jdfksdjsl',
        number: 3078
    },'2025-09-18': {
        word: 'CNEAS',
        meaning: 'jdfksdjsl',
        number: 3079
    },'2025-09-19': {
        word: 'LEACA',
        meaning: 'jdfksdjsl',
        number: 3080
    },'2025-09-20': {
        word: 'THOIR',
        meaning: 'jdfksdjsl',
        number: 3081
    },'2025-09-21': {
        word: 'EAGAL',
        meaning: 'jdfksdjsl',
        number: 3082
    },'2025-09-22': {
        word: 'CRUAS',
        meaning: 'jdfksdjsl',
        number: 3083
    },'2025-09-23': {
        word: 'SCÓIP',
        meaning: 'jdfksdjsl',
        number: 3084
    },'2025-09-24': {
        word: 'PRÓCA',
        meaning: 'jdfksdjsl',
        number: 3085
    },'2025-09-25': {
        word: 'CRAOS',
        meaning: 'jdfksdjsl',
        number: 3086
    },'2025-09-26': {
        word: 'FAIDE',
        meaning: 'jdfksdjsl',
        number: 3087
    },'2025-09-27': {
        word: 'CADÁS',
        meaning: 'jdfksdjsl',
        number: 3088
    },'2025-09-28': {
        word: 'GLINN',
        meaning: 'jdfksdjsl',
        number: 3089
    },'2025-09-29': {
        word: 'PLAIC',
        meaning: 'jdfksdjsl',
        number: 3090
    },'2025-09-30': {
        word: 'CAILC',
        meaning: 'jdfksdjsl',
        number: 3091
    },'2025-10-01': {
        word: 'LUAIL',
        meaning: 'jdfksdjsl',
        number: 3092
    },'2025-10-02': {
        word: 'LUAIL',
        meaning: 'jdfksdjsl',
        number: 3093
    },'2025-10-03': {
        word: 'CORDA',
        meaning: 'jdfksdjsl',
        number: 3094
    },'2025-10-04': {
        word: 'NUIGE',
        meaning: 'jdfksdjsl',
        number: 3095
    },'2025-10-05': {
        word: 'CLÚID',
        meaning: 'jdfksdjsl',
        number: 3096
    },'2025-10-06': {
        word: 'ÁIRID',
        meaning: 'jdfksdjsl',
        number: 3097
    },'2025-10-07': {
        word: 'GIÚIS',
        meaning: 'jdfksdjsl',
        number: 3098
    },'2025-10-08': {
        word: 'ÉIRIC',
        meaning: 'jdfksdjsl',
        number: 3099
    },'2025-10-09': {
        word: 'SEODA',
        meaning: 'jdfksdjsl',
        number: 3100
    },'2025-10-10': {
        word: 'CRUIT',
        meaning: 'jdfksdjsl',
        number: 3101
    },'2025-10-11': {
        word: 'BIÚRÓ',
        meaning: 'jdfksdjsl',
        number: 3102
    },'2025-10-12': {
        word: 'CHAON',
        meaning: 'jdfksdjsl',
        number: 3103
    },'2025-10-13': {
        word: 'SMEAR',
        meaning: 'jdfksdjsl',
        number: 3104
    },'2025-10-14': {
        word: 'MÓTAR',
        meaning: 'jdfksdjsl',
        number: 3105
    },'2025-10-15': {
        word: 'FIDIL',
        meaning: 'jdfksdjsl',
        number: 3106
    },'2025-10-16': {
        word: 'STRAC',
        meaning: 'jdfksdjsl',
        number: 3107
    },'2025-10-17': {
        word: 'PLOTA',
        meaning: 'jdfksdjsl',
        number: 3108
    },'2025-10-18': {
        word: 'CUÓTA',
        meaning: 'jdfksdjsl',
        number: 3109
    },'2025-10-19': {
        word: 'ÍOSTA',
        meaning: 'jdfksdjsl',
        number: 3110
    },'2025-10-20': {
        word: 'CLÓCA',
        meaning: 'jdfksdjsl',
        number: 3111
    },'2025-10-21': {
        word: 'BLIGH',
        meaning: 'jdfksdjsl',
        number: 3112
    },'2025-10-22': {
        word: 'GASRA',
        meaning: 'jdfksdjsl',
        number: 3113
    },'2025-10-23': {
        word: 'LÚFAR',
        meaning: 'jdfksdjsl',
        number: 3114
    },'2025-10-24': {
        word: 'SÁINN',
        meaning: 'jdfksdjsl',
        number: 3115
    },'2025-10-25': {
        word: 'GEÁBH',
        meaning: 'jdfksdjsl',
        number: 3116
    },'2025-10-26': {
        word: 'CREIG',
        meaning: 'jdfksdjsl',
        number: 3117
    },'2025-10-27': {
        word: 'DRONG',
        meaning: 'jdfksdjsl',
        number: 3118
    },'2025-10-28': {
        word: 'CÁBLA',
        meaning: 'jdfksdjsl',
        number: 3119
    },'2025-10-29': {
        word: 'TIÚIN',
        meaning: 'jdfksdjsl',
        number: 3120
    },'2025-10-30': {
        word: 'RUBAR',
        meaning: 'jdfksdjsl',
        number: 3121
    },'2025-10-31': {
        word: 'TEORA',
        meaning: 'jdfksdjsl',
        number: 3122
    },'2025-11-01': {
        word: 'IARLA',
        meaning: 'jdfksdjsl',
        number: 3123
    },'2025-11-02': {
        word: 'LADAR',
        meaning: 'jdfksdjsl',
        number: 3124
    },'2025-11-03': {
        word: 'GÉIRE',
        meaning: 'jdfksdjsl',
        number: 3125
    },'2025-11-04': {
        word: 'CEADÚ',
        meaning: 'jdfksdjsl',
        number: 3126
    },'2025-11-05': {
        word: 'PÉINE',
        meaning: 'jdfksdjsl',
        number: 3127
    },'2025-11-06': {
        word: 'LAGAR',
        meaning: 'jdfksdjsl',
        number: 3128
    },'2025-11-07': {
        word: 'TÁTAL',
        meaning: 'jdfksdjsl',
        number: 3129
    },'2025-11-08': {
        word: 'FEANN',
        meaning: 'jdfksdjsl',
        number: 3130
    },'2025-11-09': {
        word: 'DEILF',
        meaning: 'jdfksdjsl',
        number: 3131
    },'2025-11-10': {
        word: 'MACHA',
        meaning: 'jdfksdjsl',
        number: 3132
    },'2025-11-11': {
        word: 'OISRE',
        meaning: 'jdfksdjsl',
        number: 3133
    },'2025-11-12': {
        word: 'BANDA',
        meaning: 'jdfksdjsl',
        number: 3134
    },'2025-11-13': {
        word: 'SMÚIT',
        meaning: 'jdfksdjsl',
        number: 3135
    },'2025-11-14': {
        word: 'BRÍCE',
        meaning: 'jdfksdjsl',
        number: 3136
    },'2025-11-15': {
        word: 'STÉIG',
        meaning: 'jdfksdjsl',
        number: 3137
    },'2025-11-16': {
        word: 'CÓGAS',
        meaning: 'jdfksdjsl',
        number: 3138
    },'2025-11-17': {
        word: 'BAGÚN',
        meaning: 'jdfksdjsl',
        number: 3139
    },'2025-11-18': {
        word: 'GAOIS',
        meaning: 'jdfksdjsl',
        number: 3140
    },'2025-11-19': {
        word: 'SEASC',
        meaning: 'jdfksdjsl',
        number: 3141
    },'2025-11-20': {
        word: 'DARNA',
        meaning: 'jdfksdjsl',
        number: 3142
    },'2025-11-21': {
        word: 'SCINN',
        meaning: 'jdfksdjsl',
        number: 3143
    },'2025-11-22': {
        word: 'DARNA',
        meaning: 'jdfksdjsl',
        number: 3144
    },'2025-11-23': {
        word: 'SCRIÚ',
        meaning: 'jdfksdjsl',
        number: 3145
    },'2025-11-24': {
        word: 'EORNA',
        meaning: 'jdfksdjsl',
        number: 3146
    },'2025-11-25': {
        word: 'GRÍOS',
        meaning: 'jdfksdjsl',
        number: 3147
    },'2025-11-26': {
        word: 'BOLTA',
        meaning: 'jdfksdjsl',
        number: 3148
    },'2025-11-27': {
        word: 'LASTA',
        meaning: 'jdfksdjsl',
        number: 3149
    },'2025-11-28': {
        word: 'ÁIRSE',
        meaning: 'jdfksdjsl',
        number: 3150
    },'2025-11-29': {
        word: 'EASNA',
        meaning: 'jdfksdjsl',
        number: 3151
    },'2025-11-30': {
        word: 'RIASC',
        meaning: 'jdfksdjsl',
        number: 3152
    },'2025-12-01': {
        word: 'PUNTA',
        meaning: 'jdfksdjsl',
        number: 3153
    },'2025-12-02': {
        word: 'INÍOR',
        meaning: 'jdfksdjsl',
        number: 3154
    },'2025-12-03': {
        word: 'ACLAÍ',
        meaning: 'jdfksdjsl',
        number: 3155
    },'2025-12-04': {
        word: 'CRÁIN',
        meaning: 'jdfksdjsl',
        number: 3156
    },'2025-12-05': {
        word: 'CUNTA',
        meaning: 'jdfksdjsl',
        number: 3157
    },'2025-12-06': {
        word: 'TACAÍ',
        meaning: 'jdfksdjsl',
        number: 3158
    },'2025-12-07': {
        word: 'TREIS',
        meaning: 'jdfksdjsl',
        number: 3159
    },'2025-12-08': {
        word: 'SCEAN',
        meaning: 'jdfksdjsl',
        number: 3160
    },'2025-12-09': {
        word: 'TRÚPA',
        meaning: 'jdfksdjsl',
        number: 3161
    },'2025-12-10': {
        word: 'CEIRT',
        meaning: 'jdfksdjsl',
        number: 3162
    },'2025-12-11': {
        word: 'CÉILÍ',
        meaning: 'jdfksdjsl',
        number: 3163
    },'2025-12-12': {
        word: 'FOGHA',
        meaning: 'jdfksdjsl',
        number: 3164
    },'2025-12-13': {
        word: 'SPOCH',
        meaning: 'jdfksdjsl',
        number: 3165
    },'2025-12-14': {
        word: 'CASLA',
        meaning: 'jdfksdjsl',
        number: 3166
    },'2025-12-15': {
        word: 'EAGNA',
        meaning: 'jdfksdjsl',
        number: 3167
    },'2025-12-16': {
        word: 'GOBÁN',
        meaning: 'jdfksdjsl',
        number: 3168
    },'2025-12-17': {
        word: 'ISPÍN',
        meaning: 'jdfksdjsl',
        number: 3169
    },'2025-12-18': {
        word: 'ÚRACH',
        meaning: 'jdfksdjsl',
        number: 3170
    },'2025-12-19': {
        word: 'BABAÍ',
        meaning: 'jdfksdjsl',
        number: 3171
    },'2025-12-20': {
        word: 'SEILE',
        meaning: 'jdfksdjsl',
        number: 3172
    },'2025-12-21': {
        word: 'THÉID',
        meaning: 'jdfksdjsl',
        number: 3172
    },'2025-12-22': {
        word: 'FEART',
        meaning: 'jdfksdjsl',
        number: 3172
    },'2025-12-23': {
        word: 'UAILL',
        meaning: 'jdfksdjsl',
        number: 3172
    },'2025-12-24': {
        word: 'TREAS',
        meaning: 'jdfksdjsl',
        number: 3172
    },'2025-12-25': {
        word: 'IAIGH',
        meaning: 'jdfksdjsl',
        number: 3172
    },'2025-12-26': {
        word: 'FISIC',
        meaning: 'jdfksdjsl',
        number: 3172
    },'2025-12-27': {
        word: 'ÍSLIÚ',
        meaning: 'jdfksdjsl',
        number: 3172
    },'2025-12-28': {
        word: 'CLING',
        meaning: 'jdfksdjsl',
        number: 3172
    },'2025-12-29': {
        word: 'GNAOI',
        meaning: 'jdfksdjsl',
        number: 3172
    },'2025-12-30': {
        word: 'MEIRG',
        meaning: 'jdfksdjsl',
        number: 3172
    },'2025-12-31': {
        word: 'LIRIC',
        meaning: 'jdfksdjsl',
        number: 3172
    },'2026-01-01': {
        word: 'SEANG',
        meaning: 'jdfksdjsl',
        number: 3173
    },'2026-01-02': {
        word: 'FRÍTH',
        meaning: 'jdfksdjsl',
        number: 3174
    },'2026-01-03': {
        word: 'CEALG',
        meaning: 'jdfksdjsl',
        number: 3175
    },'2026-01-04': {
        word: 'CEILP',
        meaning: 'jdfksdjsl',
        number: 3176
    },'2026-01-05': {
        word: 'GALÚN',
        meaning: 'jdfksdjsl',
        number: 3177
    },'2026-01-06': {
        word: 'CODÁN',
        meaning: 'jdfksdjsl',
        number: 3178
    },'2026-01-07': {
        word: 'TROSC',
        meaning: 'jdfksdjsl',
        number: 3179
    },'2026-01-08': {
        word: 'CÍRÍN',
        meaning: 'jdfksdjsl',
        number: 3180
    },'2026-01-09': {
        word: 'FAOMH',
        meaning: 'jdfksdjsl',
        number: 3181
    },'2026-01-10': {
        word: 'LEICE',
        meaning: 'jdfksdjsl',
        number: 3182
    },'2026-01-11': {
        word: 'OCHTÚ',
        meaning: 'jdfksdjsl',
        number: 3183
    },'2026-01-12': {
        word: 'DÓLÁS',
        meaning: 'jdfksdjsl',
        number: 3184
    },'2026-01-13': {
        word: 'SCRÍN',
        meaning: 'jdfksdjsl',
        number: 3185
    },'2026-01-14': {
        word: 'SCEON',
        meaning: 'jdfksdjsl',
        number: 3186
    },'2026-01-15': {
        word: 'DIAIL',
        meaning: 'jdfksdjsl',
        number: 3187
    },'2026-01-16': {
        word: 'PIANÓ',
        meaning: 'jdfksdjsl',
        number: 3188
    },'2026-01-17': {
        word: 'SCÉIN',
        meaning: 'jdfksdjsl',
        number: 3190
    },'2026-01-18': {
        word: 'FLOSC',
        meaning: 'jdfksdjsl',
        number: 3191
    },'2026-01-19': {
        word: 'SOBAL',
        meaning: 'jdfksdjsl',
        number: 3192
    },'2026-01-20': {
        word: 'CROBH',
        meaning: 'jdfksdjsl',
        number: 3193
    },'2026-01-21': {
        word: 'MÁNLA',
        meaning: 'jdfksdjsl',
        number: 3194
    },'2026-01-22': {
        word: 'DÉINE',
        meaning: 'jdfksdjsl',
        number: 3195
    },'2026-01-23': {
        word: 'PRÓIS',
        meaning: 'jdfksdjsl',
        number: 3196
    },'2026-01-24': {
        word: 'TEARC',
        meaning: 'jdfksdjsl',
        number: 3197
    },'2026-01-25': {
        word: 'EASÓG',
        meaning: 'jdfksdjsl',
        number: 3198
    },'2026-01-26': {
        word: 'BAILÍ',
        meaning: 'jdfksdjsl',
        number: 3199
    },'2026-01-27': {
        word: 'MARÓG',
        meaning: 'jdfksdjsl',
        number: 3200
    },'2026-01-28': {
        word: 'GOIMH',
        meaning: 'jdfksdjsl',
        number: 3201
    },'2026-01-29': {
        word: 'SCOLB',
        meaning: 'jdfksdjsl',
        number: 3202
    },'2026-01-30': {
        word: 'SONRÚ',
        meaning: 'jdfksdjsl',
        number: 3203
    },'2026-01-31': {
        word: 'MNAOI',
        meaning: 'jdfksdjsl',
        number: 3204
    },'2026-02-01': {
        word: 'SRANN',
        meaning: 'jdfksdjsl',
        number: 3205
    },'2026-02-02': {
        word: 'EITIC',
        meaning: 'jdfksdjsl',
        number: 3205
    },'2026-02-03': {
        word: 'BÁITH',
        meaning: 'jdfksdjsl',
        number: 3206
    },'2026-02-04': {
        word: 'TIGHE',
        meaning: 'jdfksdjsl',
        number: 3207
    },'2026-02-05': {
        word: 'CRÚCA',
        meaning: 'jdfksdjsl',
        number: 3208
    },'2026-02-06': {
        word: 'LEITE',
        meaning: 'jdfksdjsl',
        number: 3209
    },'2026-02-07': {
        word: 'SEARR',
        meaning: 'jdfksdjsl',
        number: 3210
    },'2026-02-08': {
        word: 'BAOTH',
        meaning: 'jdfksdjsl',
        number: 3211
    },'2026-02-09': {
        word: 'CALMA',
        meaning: 'jdfksdjsl',
        number: 3212
    },'2026-02-10': {
        word: 'FÁILÍ',
        meaning: 'jdfksdjsl',
        number: 3213
    },'2026-02-11': {
        word: 'CURFÁ',
        meaning: 'jdfksdjsl',
        number: 3214
    },'2026-02-12': {
        word: 'SLINN',
        meaning: 'jdfksdjsl',
        number: 3215
    },'2026-02-13': {
        word: 'MÚNLÚ',
        meaning: 'jdfksdjsl',
        number: 3216
    },'2026-02-14': {
        word: 'CRÍON',
        meaning: 'jdfksdjsl',
        number: 3217
    },'2026-02-15': {
        word: 'TARRA',
        meaning: 'jdfksdjsl',
        number: 3218
    },'2026-02-16': {
        word: 'FÍOCH',
        meaning: 'jdfksdjsl',
        number: 3219
    },'2026-02-17': {
        word: 'BUACH',
        meaning: 'jdfksdjsl',
        number: 3220
    },'2026-02-18': {
        word: 'CORNA',
        meaning: 'jdfksdjsl',
        number: 3221
    },'2026-02-19': {
        word: 'BARDA',
        meaning: 'jdfksdjsl',
        number: 3222
    },'2026-02-20': {
        word: 'ÉIDIR',
        meaning: 'jdfksdjsl',
        number: 3223
    },'2026-02-21': {
        word: 'SNIGH',
        meaning: 'jdfksdjsl',
        number: 3224
    },'2026-02-22': {
        word: 'BEOGA',
        meaning: 'jdfksdjsl',
        number: 3225
    },'2026-02-23': {
        word: 'BÁSTA',
        meaning: 'jdfksdjsl',
        number: 3226
    },'2026-02-24': {
        word: 'FUÁIL',
        meaning: 'jdfksdjsl',
        number: 3227
    },'2026-02-25': {
        word: 'CAMAS',
        meaning: 'jdfksdjsl',
        number: 3228
    },'2026-02-26': {
        word: 'SPEAL',
        meaning: 'jdfksdjsl',
        number: 3229
    },'2026-02-27': {
        word: 'COISÍ',
        meaning: 'jdfksdjsl',
        number: 3230
    },'2026-02-28': {
        word: 'SCIÚR',
        meaning: 'jdfksdjsl',
        number: 3231
    },'2026-03-01': {
        word: 'TÓRAÍ',
        meaning: 'jdfksdjsl',
        number: 3232
    },'2026-03-02': {
        word: 'DÍLEÁ',
        meaning: 'jdfksdjsl',
        number: 3233
    },'2026-03-03': {
        word: 'SPALP',
        meaning: 'jdfksdjsl',
        number: 3234
    },'2026-03-04': {
        word: 'CEANT',
        meaning: 'jdfksdjsl',
        number: 3235
    },'2026-03-05': {
        word: 'FÁNAÍ',
        meaning: 'jdfksdjsl',
        number: 3236
    },'2026-03-06': {
        word: 'SAOBH',
        meaning: 'jdfksdjsl',
        number: 3237
    },'2026-03-07': {
        word: 'BRÁTH',
        meaning: 'jdfksdjsl',
        number: 3238
    },'2026-03-08': {
        word: 'SEARG',
        meaning: 'jdfksdjsl',
        number: 3239
    },'2026-03-09': {
        word: 'FALLA',
        meaning: 'jdfksdjsl',
        number: 3240
    },'2026-03-10': {
        word: 'DRÚIS',
        meaning: 'jdfksdjsl',
        number: 3241
    },'2026-03-11': {
        word: 'SLÍOC',
        meaning: 'jdfksdjsl',
        number: 3242
    },'2026-03-12': {
        word: 'GRÁIG',
        meaning: 'jdfksdjsl',
        number: 3243
    },'2026-03-13': {
        word: 'OIBIR',
        meaning: 'jdfksdjsl',
        number: 3244
    },'2026-03-14': {
        word: 'FALSA',
        meaning: 'jdfksdjsl',
        number: 3245
    },'2026-03-15': {
        word: 'TRÉAS',
        meaning: 'jdfksdjsl',
        number: 3246
    },'2026-03-16': {
        word: 'RADAR',
        meaning: 'jdfksdjsl',
        number: 3247
    },'2026-03-17': {
        word: 'OIDHE',
        meaning: 'jdfksdjsl',
        number: 3248
    },'2026-03-18': {
        word: 'BREAB',
        meaning: 'jdfksdjsl',
        number: 3249
    },'2026-03-19': {
        word: 'MATAL',
        meaning: 'jdfksdjsl',
        number: 3250
    },'2026-03-20': {
        word: 'BAOIS',
        meaning: 'jdfksdjsl',
        number: 3251
    },'2026-03-21': {
        word: 'MARAÍ',
        meaning: 'jdfksdjsl',
        number: 3252
    },'2026-03-22': {
        word: 'BÁCÚS',
        meaning: 'jdfksdjsl',
        number: 3253
    },'2026-03-23': {
        word: 'EILIT',
        meaning: 'jdfksdjsl',
        number: 3254
    },'2026-03-24': {
        word: 'CNEAD',
        meaning: 'jdfksdjsl',
        number: 3255
    },'2026-03-25': {
        word: 'DRANN',
        meaning: 'jdfksdjsl',
        number: 3256
    },'2026-03-26': {
        word: 'SCUAD',
        meaning: 'jdfksdjsl',
        number: 3257
    },'2026-03-27': {
        word: 'BALÚN',
        meaning: 'jdfksdjsl',
        number: 3258
    },'2026-03-28': {
        word: 'GAIBH',
        meaning: 'jdfksdjsl',
        number: 3259
    },'2026-03-29': {
        word: 'ÁRACH',
        meaning: 'jdfksdjsl',
        number: 3260
    },'2026-03-30': {
        word: 'BULAÍ',
        meaning: 'jdfksdjsl',
        number: 3261
    },'2026-03-31': {
        word: 'SANAS',
        meaning: 'jdfksdjsl',
        number: 3262
    },'2026-04-01': {
        word: 'GUAIM',
        meaning: 'jdfksdjsl',
        number: 3263
    },'2026-04-02': {
        word: 'DUSTA',
        meaning: 'jdfksdjsl',
        number: 3264
    },'2026-04-03': {
        word: 'CUAIN',
        meaning: 'jdfksdjsl',
        number: 3265
    },'2026-04-04': {
        word: 'PLIMP',
        meaning: 'jdfksdjsl',
        number: 3266
    },'2026-04-05': {
        word: 'OCHÓN',
        meaning: 'jdfksdjsl',
        number: 3267
    },'2026-04-06': {
        word: 'STÁIR',
        meaning: 'jdfksdjsl',
        number: 3268
    },'2026-04-07': {
        word: 'IOMPÚ',
        meaning: 'jdfksdjsl',
        number: 3269
    },'2026-04-08': {
        word: 'BOIGE',
        meaning: 'jdfksdjsl',
        number: 3270
    },'2026-04-09': {
        word: 'SILÍN',
        meaning: 'jdfksdjsl',
        number: 3271
    },'2026-04-10': {
        word: 'DOIRE',
        meaning: 'jdfksdjsl',
        number: 3272
    },'2026-04-11': {
        word: 'RANGÚ',
        meaning: 'jdfksdjsl',
        number: 3273
    },'2026-04-12': {
        word: 'LÉANA',
        meaning: 'jdfksdjsl',
        number: 3274
    },'2026-04-13': {
        word: 'CANTA',
        meaning: 'jdfksdjsl',
        number: 3275
    },'2026-04-14': {
        word: 'BÁINÍ',
        meaning: 'jdfksdjsl',
        number: 3276
    },'2026-04-15': {
        word: 'SEORT',
        meaning: 'jdfksdjsl',
        number: 3277
    },'2026-04-16': {
        word: 'DALBA',
        meaning: 'jdfksdjsl',
        number: 3277
    },'2026-04-17': {
        word: 'SEARC',
        meaning: 'jdfksdjsl',
        number: 3278
    },'2026-04-18': {
        word: 'CASÁN',
        meaning: 'jdfksdjsl',
        number: 3279
    },'2026-04-19': {
        word: 'TOILL',
        meaning: 'jdfksdjsl',
        number: 3280
    },'2026-04-20': {
        word: 'TRUNC',
        meaning: 'jdfksdjsl',
        number: 3281
    },'2026-04-21': {
        word: 'CUMAR',
        meaning: 'jdfksdjsl',
        number: 3282
    },'2026-04-22': {
        word: 'ANÁLÚ',
        meaning: 'jdfksdjsl',
        number: 3283
    },'2026-04-23': {
        word: 'SCÁIN',
        meaning: 'jdfksdjsl',
        number: 3284
    },'2026-04-24': {
        word: 'SCINE',
        meaning: 'jdfksdjsl',
        number: 3285
    },'2026-04-25': {
        word: 'CUILT',
        meaning: 'jdfksdjsl',
        number: 3286
    },'2026-04-26': {
        word: 'MUIRÍ',
        meaning: 'jdfksdjsl',
        number: 3287
    },'2026-04-27': {
        word: 'TRÚIG',
        meaning: 'jdfksdjsl',
        number: 3288
    },'2026-04-28': {
        word: 'LACHT',
        meaning: 'jdfksdjsl',
        number: 3289
    },'2026-04-29': {
        word: 'CÁITH',
        meaning: 'jdfksdjsl',
        number: 3290
    },'2026-04-30': {
        word: 'SOTAL',
        meaning: 'jdfksdjsl',
        number: 3291
    },'2026-05-01': {
        word: 'MÚISC',
        meaning: 'jdfksdjsl',
        number: 3292
    },'2026-05-02': {
        word: 'CURAÍ',
        meaning: 'jdfksdjsl',
        number: 3293
    },'2026-05-03': {
        word: 'BUIRG',
        meaning: 'jdfksdjsl',
        number: 3294
    },'2026-05-04': {
        word: 'RACÁN',
        meaning: 'jdfksdjsl',
        number: 3295
    },'2026-05-05': {
        word: 'LÉIMT',
        meaning: 'jdfksdjsl',
        number: 3296
    },'2026-05-06': {
        word: 'BRÁCA',
        meaning: 'jdfksdjsl',
        number: 3297
    },'2026-05-07': {
        word: 'STRÓC',
        meaning: 'jdfksdjsl',
        number: 3298
    },'2026-05-08': {
        word: 'LÁBÁN',
        meaning: 'jdfksdjsl',
        number: 3299
    },'2026-05-09': {
        word: 'COLPA',
        meaning: 'jdfksdjsl',
        number: 3300
    },'2026-05-10': {
        word: 'OGHAM',
        meaning: 'jdfksdjsl',
        number: 3301
    },'2026-05-11': {
        word: 'LONNÚ',
        meaning: 'jdfksdjsl',
        number: 3302
    },'2026-05-12': {
        word: 'CALÓG',
        meaning: 'jdfksdjsl',
        number: 3303
    },'2026-05-13': {
        word: 'CÉIDE',
        meaning: 'jdfksdjsl',
        number: 3304
    },'2026-05-14': {
        word: 'DAMNÚ',
        meaning: 'jdfksdjsl',
        number: 3305
    },'2026-05-15': {
        word: 'DLAOI',
        meaning: 'jdfksdjsl',
        number: 3306
    },'2026-05-16': {
        word: 'EIPIC',
        meaning: 'jdfksdjsl',
        number: 3307
    },'2026-05-17': {
        word: 'AIBÍD',
        meaning: 'jdfksdjsl',
        number: 3308
    },'2026-05-18': {
        word: 'MOING',
        meaning: 'jdfksdjsl',
        number: 3309
    },'2026-05-19': {
        word: 'LORGA',
        meaning: 'jdfksdjsl',
        number: 3310
    },'2026-05-20': {
        word: 'BULLA',
        meaning: 'jdfksdjsl',
        number: 3311
    },'2026-05-21': {
        word: 'STÁCA',
        meaning: 'jdfksdjsl',
        number: 3312
    },'2026-05-22': {
        word: 'PAILM',
        meaning: 'jdfksdjsl',
        number: 3313
    },'2026-05-23': {
        word: 'CAISE',
        meaning: 'jdfksdjsl',
        number: 3314
    },'2026-05-24': {
        word: 'STIÚG',
        meaning: 'jdfksdjsl',
        number: 3315
    },'2026-05-25': {
        word: 'POLLA',
        meaning: 'jdfksdjsl',
        number: 3316
    },'2026-05-26': {
        word: 'SLEÁN',
        meaning: 'jdfksdjsl',
        number: 3317
    },'2026-05-27': {
        word: 'MUINE',
        meaning: 'jdfksdjsl',
        number: 3318
    },'2026-05-28': {
        word: 'FONSA',
        meaning: 'jdfksdjsl',
        number: 3319
    },'2026-05-29': {
        word: 'PLUMA',
        meaning: 'jdfksdjsl',
        number: 3320
    },'2026-05-30': {
        word: 'BÓLAÍ',
        meaning: 'jdfksdjsl',
        number: 3321
    },'2026-05-31': {
        word: 'BURLA',
        meaning: 'jdfksdjsl',
        number: 3322
    },'2026-06-01': {
        word: 'TEASC',
        meaning: 'jdfksdjsl',
        number: 3323
    },'2026-06-02': {
        word: 'UASTA',
        meaning: 'jdfksdjsl',
        number: 3324
    },'2026-06-03': {
        word: 'DÍLSE',
        meaning: 'jdfksdjsl',
        number: 3325
    },'2026-06-04': {
        word: 'DRAID',
        meaning: 'jdfksdjsl',
        number: 3326
    },'2026-06-05': {
        word: 'DUINE',
        meaning: 'jdfksdjsl',
        number: 3327
    },'2026-06-06': {
        word: 'ABAIR',
        meaning: 'jdfksdjsl',
        number: 3328
    },'2026-06-07': {
        word: 'MAITH',
        meaning: 'jdfksdjsl',
        number: 3329
    },'2026-06-08': {
        word: 'FAIGH',
        meaning: 'jdfksdjsl',
        number: 3330
    },'2026-06-09': {
        word: 'TÉIGH',
        meaning: 'jdfksdjsl',
        number: 3331
    },'2026-06-10': {
        word: 'NUAIR',
        meaning: 'jdfksdjsl',
        number: 3332
    },'2026-06-11': {
        word: 'AMACH',
        meaning: 'jdfksdjsl',
        number: 3333
    },'2026-06-12': {
        word: 'CEANN',
        meaning: 'jdfksdjsl',
        number: 3334
    },'2026-06-13': {
        word: 'CAITH',
        meaning: 'jdfksdjsl',
        number: 3335
    },'2026-06-14': {
        word: 'CHOMH',
        meaning: 'jdfksdjsl',
        number: 3336
    },'2026-06-15': {
        word: 'CHUIG',
        meaning: 'jdfksdjsl',
        number: 3337
    },'2026-06-16': {
        word: 'OBAIR',
        meaning: 'jdfksdjsl',
        number: 3338
    },'2026-06-17': {
        word: 'TAOBH',
        meaning: 'jdfksdjsl',
        number: 3339
    },'2026-06-18': {
        word: 'ANOIS',
        meaning: 'jdfksdjsl',
        number: 3340
    },'2026-06-19': {
        word: 'CÉILE',
        meaning: 'jdfksdjsl',
        number: 3341
    },'2026-06-20': {
        word: 'TEACH',
        meaning: 'jdfksdjsl',
        number: 3342
    },'2026-06-21': {
        word: 'CEART',
        meaning: 'jdfksdjsl',
        number: 3343
    },'2026-06-22': {
        word: 'SCÉAL',
        meaning: 'jdfksdjsl',
        number: 3344
    },'2026-06-23': {
        word: 'ROIMH',
        meaning: 'jdfksdjsl',
        number: 3345
    },'2026-06-24': {
        word: 'CEIST',
        meaning: 'jdfksdjsl',
        number: 3346
    },'2026-06-25': {
        word: 'ANSIN',
        meaning: 'jdfksdjsl',
        number: 3347
    },'2026-06-26': {
        word: 'DÓIGH',
        meaning: 'jdfksdjsl',
        number: 3348
    },'2026-06-27': {
        word: 'POBAL',
        meaning: 'jdfksdjsl',
        number: 3349
    },'2026-06-28': {
        word: 'SCOIL',
        meaning: 'jdfksdjsl',
        number: 3350
    },'2026-06-29': {
        word: 'ROINN',
        meaning: 'jdfksdjsl',
        number: 3351
    },'2026-06-30': {
        word: 'ÚSÁID',
        meaning: 'jdfksdjsl',
        number: 3352
    },'2026-07-01': {
        word: 'LEITH',
        meaning: 'jdfksdjsl',
        number: 3353
    },'2026-07-02': {
        word: 'ANSEO',
        meaning: 'jdfksdjsl',
        number: 3354
    },'2026-07-03': {
        word: 'OÍCHE',
        meaning: 'jdfksdjsl',
        number: 3355
    },'2026-07-04': {
        word: 'BAILE',
        meaning: 'jdfksdjsl',
        number: 3356
    },'2026-07-05': {
        word: 'LUCHT',
        meaning: 'jdfksdjsl',
        number: 3357
    },'2026-07-06': {
        word: 'CÚRSA',
        meaning: 'jdfksdjsl',
        number: 3358
    },'2026-07-07': {
        word: 'EOLAS',
        meaning: 'jdfksdjsl',
        number: 3359
    },'2026-07-08': {
        word: 'IMIGH',
        meaning: 'jdfksdjsl',
        number: 3360
    },'2026-07-09': {
        word: 'CAINT',
        meaning: 'jdfksdjsl',
        number: 3361
    },'2026-07-10': {
        word: 'ÁBHAR',
        meaning: 'jdfksdjsl',
        number: 3362
    },'2026-07-11': {
        word: 'FÉACH',
        meaning: 'jdfksdjsl',
        number: 3363
    },'2026-07-12': {
        word: 'SIÚIL',
        meaning: 'jdfksdjsl',
        number: 3364
    },'2026-07-13': {
        word: 'ÉIGIN',
        meaning: 'jdfksdjsl',
        number: 3365
    },'2026-07-14': {
        word: 'BUAIL',
        meaning: 'jdfksdjsl',
        number: 3366
    },'2026-07-15': {
        word: 'RIAMH',
        meaning: 'jdfksdjsl',
        number: 3367
    },'2026-07-16': {
        word: 'FOCAL',
        meaning: 'jdfksdjsl',
        number: 3368
    },'2026-07-17': {
        word: 'BEIRT',
        meaning: 'jdfksdjsl',
        number: 3369
    },'2026-07-18': {
        word: 'MEASC',
        meaning: 'jdfksdjsl',
        number: 3370
    },'2026-07-19': {
        word: 'CLOIS',
        meaning: 'jdfksdjsl',
        number: 3371
    },'2026-07-20': {
        word: 'CÓNAÍ',
        meaning: 'jdfksdjsl',
        number: 3372
    },'2026-07-21': {
        word: 'THART',
        meaning: 'jdfksdjsl',
        number: 3373
    },'2026-07-22': {
        word: 'MINIC',
        meaning: 'jdfksdjsl',
        number: 3374
    },'2026-07-23': {
        word: 'ANUAS',
        meaning: 'jdfksdjsl',
        number: 3375
    },'2026-07-24': {
        word: 'IONAD',
        meaning: 'jdfksdjsl',
        number: 3376
    },'2026-07-25': {
        word: 'UISCE',
        meaning: 'jdfksdjsl',
        number: 3377
    },'2026-07-26': {
        word: 'GEALL',
        meaning: 'jdfksdjsl',
        number: 3378
    },'2026-07-27': {
        word: 'CÚPLA',
        meaning: 'jdfksdjsl',
        number: 3379
    },'2026-07-28': {
        word: 'CÚIRT',
        meaning: 'jdfksdjsl',
        number: 3380
    },'2026-07-29': {
        word: 'DORAS',
        meaning: 'jdfksdjsl',
        number: 3381
    },'2026-07-30': {
        word: 'OIFIG',
        meaning: 'jdfksdjsl',
        number: 3382
    },'2026-07-31': {
        word: 'CÓRAS',
        meaning: 'jdfksdjsl',
        number: 3383
    },'2026-08-01': {
        word: 'MÓRÁN',
        meaning: 'jdfksdjsl',
        number: 3384
    },'2026-08-02': {
        word: 'SÁSTA',
        meaning: 'jdfksdjsl',
        number: 3385
    },'2026-08-03': {
        word: 'INNIU',
        meaning: 'jdfksdjsl',
        number: 3386
    },'2026-08-04': {
        word: 'SUIGH',
        meaning: 'jdfksdjsl',
        number: 3387
    },'2026-08-05': {
        word: 'BREIS',
        meaning: 'jdfksdjsl',
        number: 3388
    },'2026-08-06': {
        word: 'SRÁID',
        meaning: 'jdfksdjsl',
        number: 3389
    },'2026-08-07': {
        word: 'CAILL',
        meaning: 'jdfksdjsl',
        number: 3390
    },'2026-08-08': {
        word: 'GEARR',
        meaning: 'jdfksdjsl',
        number: 3391
    },'2026-08-09': {
        word: 'ÁFACH',
        meaning: 'jdfksdjsl',
        number: 3392
    },'2026-08-10': {
        word: 'CREID',
        meaning: 'jdfksdjsl',
        number: 3393
    },'2026-08-11': {
        word: 'LUATH',
        meaning: 'jdfksdjsl',
        number: 3394
    },'2026-08-12': {
        word: 'GRÚPA',
        meaning: 'jdfksdjsl',
        number: 3395
    },'2026-08-13': {
        word: 'FADHB',
        meaning: 'jdfksdjsl',
        number: 3396
    },'2026-08-14': {
        word: 'SCÉIM',
        meaning: 'jdfksdjsl',
        number: 3397
    },'2026-08-15': {
        word: 'SEANS',
        meaning: 'jdfksdjsl',
        number: 3398
    },'2026-08-16': {
        word: 'BOCHT',
        meaning: 'jdfksdjsl',
        number: 3399
    },'2026-08-17': {
        word: 'THIAR',
        meaning: 'jdfksdjsl',
        number: 3400
    },'2026-08-18': {
        word: 'TUILL',
        meaning: 'jdfksdjsl',
        number: 3401
    },'2026-08-19': {
        word: 'LACHA',
        meaning: 'jdfksdjsl',
        number: 3402
    },'2026-08-20': {
        word: 'GAOTH',
        meaning: 'jdfksdjsl',
        number: 3403
    },'2026-08-21': {
        word: 'DREAM',
        meaning: 'jdfksdjsl',
        number: 3404
    },'2026-08-22': {
        word: 'CUMAS',
        meaning: 'jdfksdjsl',
        number: 3405
    },'2026-08-23': {
        word: 'TRÁTH',
        meaning: 'jdfksdjsl',
        number: 3406
    },'2026-08-24': {
        word: 'CLANN',
        meaning: 'jdfksdjsl',
        number: 3407
    },'2026-08-25': {
        word: 'STAIR',
        meaning: 'jdfksdjsl',
        number: 3408
    },'2026-08-26': {
        word: 'CÚRAM',
        meaning: 'jdfksdjsl',
        number: 3409
    },'2026-08-27': {
        word: 'ATHRÚ',
        meaning: 'jdfksdjsl',
        number: 3410
    },'2026-08-28': {
        word: 'TOISC',
        meaning: 'jdfksdjsl',
        number: 3411
    },'2026-08-29': {
        word: 'CRANN',
        meaning: 'jdfksdjsl',
        number: 3412
    },'2026-08-30': {
        word: 'PÁIRT',
        meaning: 'jdfksdjsl',
        number: 3413
    },'2026-08-31': {
        word: 'CLOCH',
        meaning: 'jdfksdjsl',
        number: 3414
    },'2026-09-01': {
        word: 'SOLAS',
        meaning: 'jdfksdjsl',
        number: 3415
    },'2026-09-02': {
        word: 'FOIRM',
        meaning: 'jdfksdjsl',
        number: 3416
    },'2026-09-03': {
        word: 'LITIR',
        meaning: 'jdfksdjsl',
        number: 3417
    },'2026-09-04': {
        word: 'PLEAN',
        meaning: 'jdfksdjsl',
        number: 3418
    },'2026-09-05': {
        word: 'PÁIRC',
        meaning: 'jdfksdjsl',
        number: 3419
    },'2026-09-06': {
        word: 'LÉANN',
        meaning: 'jdfksdjsl',
        number: 3420
    },'2026-09-07': {
        word: 'ROGHA',
        meaning: 'jdfksdjsl',
        number: 3421
    },'2026-09-08': {
        word: 'LEATH',
        meaning: 'jdfksdjsl',
        number: 3422
    },'2026-09-09': {
        word: 'FÉILE',
        meaning: 'jdfksdjsl',
        number: 3423
    },'2026-09-10': {
        word: 'UASAL',
        meaning: 'jdfksdjsl',
        number: 3424
    },'2026-09-11': {
        word: 'CONAS',
        meaning: 'jdfksdjsl',
        number: 3425
    },'2026-09-12': {
        word: 'LÉIGH',
        meaning: 'jdfksdjsl',
        number: 3426
    },'2026-09-13': {
        word: 'GRIAN',
        meaning: 'jdfksdjsl',
        number: 3427
    },'2026-09-14': {
        word: 'DÓCHA',
        meaning: 'jdfksdjsl',
        number: 3428
    },'2026-09-15': {
        word: 'PÍOSA',
        meaning: 'jdfksdjsl',
        number: 3429
    },'2026-09-16': {
        word: 'THÍOS',
        meaning: 'jdfksdjsl',
        number: 3430
    },'2026-09-17': {
        word: 'FÓILL',
        meaning: 'jdfksdjsl',
        number: 3431
    },'2026-09-18': {
        word: 'TURAS',
        meaning: 'jdfksdjsl',
        number: 3432
    },'2026-09-19': {
        word: 'LUIGH',
        meaning: 'jdfksdjsl',
        number: 3433
    },'2026-09-20': {
        word: 'BEITH',
        meaning: 'jdfksdjsl',
        number: 3434
    },'2026-09-21': {
        word: 'RIAIL',
        meaning: 'jdfksdjsl',
        number: 3435
    },'2026-09-22': {
        word: 'FÓGRA',
        meaning: 'jdfksdjsl',
        number: 3436
    },'2026-09-23': {
        word: 'THUAS',
        meaning: 'jdfksdjsl',
        number: 3437
    },'2026-09-24': {
        word: 'BEART',
        meaning: 'jdfksdjsl',
        number: 3438
    },'2026-09-25': {
        word: 'LÉAMH',
        meaning: 'jdfksdjsl',
        number: 3439
    },'2026-09-26': {
        word: 'DEARA',
        meaning: 'jdfksdjsl',
        number: 3440
    },'2026-09-27': {
        word: 'SIOPA',
        meaning: 'jdfksdjsl',
        number: 3441
    },'2026-09-28': {
        word: 'LEABA',
        meaning: 'jdfksdjsl',
        number: 3442
    },'2026-09-29': {
        word: 'DEICH',
        meaning: 'jdfksdjsl',
        number: 3434
    },'2026-09-30': {
        word: 'DEARG',
        meaning: 'jdfksdjsl',
        number: 3435
    },'2026-10-01': {
        word: 'EAGLA',
        meaning: 'jdfksdjsl',
        number: 3436
    },'2026-10-02': {
        word: 'BAINT',
        meaning: 'jdfksdjsl',
        number: 3437
    },'2026-10-03': {
        word: 'GARDA',
        meaning: 'jdfksdjsl',
        number: 3438
    },'2026-10-04': {
        word: 'DRÁMA',
        meaning: 'jdfksdjsl',
        number: 3439
    },'2026-10-05': {
        word: 'FICHE',
        meaning: 'jdfksdjsl',
        number: 3440
    },'2026-10-06': {
        word: 'LUACH',
        meaning: 'jdfksdjsl',
        number: 3441
    },'2026-10-07': {
        word: 'RÉIDH',
        meaning: 'jdfksdjsl',
        number: 3442
    },'2026-10-08': {
        word: 'NEART',
        meaning: 'jdfksdjsl',
        number: 3443
    },'2026-10-09': {
        word: 'TRIÚR',
        meaning: 'jdfksdjsl',
        number: 3444
    },'2026-10-10': {
        word: 'AONAR',
        meaning: 'jdfksdjsl',
        number: 3445
    },'2026-10-11': {
        word: 'MARBH',
        meaning: 'jdfksdjsl',
        number: 3446
    },'2026-10-12': {
        word: 'DEOCH',
        meaning: 'jdfksdjsl',
        number: 3447
    },'2026-10-13': {
        word: 'GREIM',
        meaning: 'jdfksdjsl',
        number: 3448
    },'2026-10-14': {
        word: 'FOSTA',
        meaning: 'jdfksdjsl',
        number: 3449
    },'2026-10-15': {
        word: 'DALTA',
        meaning: 'jdfksdjsl',
        number: 3450
    },'2026-10-16': {
        word: 'DROIM',
        meaning: 'jdfksdjsl',
        number: 3451
    },'2026-10-17': {
        word: 'TROID',
        meaning: 'jdfksdjsl',
        number: 3452
    },'2026-10-18': {
        word: 'BHUEL',
        meaning: 'jdfksdjsl',
        number: 3453
    },'2026-10-19': {
        word: 'ÓCÁID',
        meaning: 'jdfksdjsl',
        number: 3454
    },'2026-10-20': {
        word: 'TUATH',
        meaning: 'jdfksdjsl',
        number: 3455
    },'2026-10-21': {
        word: 'BRATH',
        meaning: 'jdfksdjsl',
        number: 3456
    },'2026-10-22': {
        word: 'CIALL',
        meaning: 'jdfksdjsl',
        number: 3457
    },'2026-10-23': {
        word: 'AIRDE',
        meaning: 'jdfksdjsl',
        number: 3458
    },'2026-10-24': {
        word: 'FORAS',
        meaning: 'jdfksdjsl',
        number: 3459
    },'2026-10-25': {
        word: 'SPÉIS',
        meaning: 'jdfksdjsl',
        number: 3460
    },'2026-10-26': {
        word: 'INÍON',
        meaning: 'jdfksdjsl',
        number: 3461
    },'2026-10-27': {
        word: 'SPÓRT',
        meaning: 'jdfksdjsl',
        number: 3462
    },'2026-10-28': {
        word: 'GNÁTH',
        meaning: 'jdfksdjsl',
        number: 3463
    },'2026-10-29': {
        word: 'BRONN',
        meaning: 'jdfksdjsl',
        number: 3464
    },'2026-10-30': {
        word: 'SOCRÚ',
        meaning: 'jdfksdjsl',
        number: 3465
    },'2026-10-31': {
        word: 'SOCRÚ',
        meaning: 'jdfksdjsl',
        number: 3466
    },'2026-11-01': {
        word: 'BLÁTH',
        meaning: 'jdfksdjsl',
        number: 3467
    },'2026-11-02': {
        word: 'THALL',
        meaning: 'jdfksdjsl',
        number: 3468
    },'2026-11-03': {
        word: 'ÍSEAL',
        meaning: 'jdfksdjsl',
        number: 3469
    },'2026-11-04': {
        word: 'GLÚIN',
        meaning: 'jdfksdjsl',
        number: 3470
    },'2026-11-05': {
        word: 'AIGNE',
        meaning: 'jdfksdjsl',
        number: 3471
    },'2026-11-06': {
        word: 'EARRA',
        meaning: 'jdfksdjsl',
        number: 3472
    },'2026-11-07': {
        word: 'AONAD',
        meaning: 'jdfksdjsl',
        number: 3473
    },'2026-11-08': {
        word: 'DUAIS',
        meaning: 'jdfksdjsl',
        number: 3474
    },'2026-11-09': {
        word: 'BALLA',
        meaning: 'jdfksdjsl',
        number: 3475
    }
}

export default dailyWord;
